import * as Yup from 'yup';
import defaultInstance from '../axiosHelper';
import { API_ENDPOINTS } from './apiEndPoints';
import moment from 'moment';

export const ROLE_TYPE = {
    STATE_COORDINATOR: 'SC',
    ASSISTANT_STATE_COORDINATOR: 'ASC',
    ZONAL_MANAGER: 'ZM',
    SUPER_VISOR: 'SV',
    FIELD_COORDINATOR: 'FC'
};

export const LOGIN_USER_TYPE = {
    NORMAL_USER: 'user',
    ADMIN: 'admin',
    SUPER_ADMIN: 'super-admin',
}

export const governmentIdOptions = [
    { value: 'Aadhar', label: 'Aadhar Card' },
    { value: 'PAN', label: 'PAN Card' },
];

export const extraGovernmentIdOptions = [
    { value: 'License', label: 'License Number' },
    { value: 'Ration', label: 'Ration Card Number' },
    { value: 'Voter', label: 'Voter ID Number' },
];

export const roleOptions = [
    { value: ROLE_TYPE.STATE_COORDINATOR, label: 'State Coordinator', reporting_manager: [] },
    { value: ROLE_TYPE.ASSISTANT_STATE_COORDINATOR, label: 'Assistant State Coordinator', reporting_manager: [{ value: ROLE_TYPE.STATE_COORDINATOR, label: 'State Coordinator', }] },
    { value: ROLE_TYPE.ZONAL_MANAGER, label: 'Zonal Manager', reporting_manager: [{ value: ROLE_TYPE.ASSISTANT_STATE_COORDINATOR, label: 'Assistant State Coordinator' }] },
    { value: ROLE_TYPE.SUPER_VISOR, label: 'Supervisor', reporting_manager: [{ value: ROLE_TYPE.ZONAL_MANAGER, label: 'Zonal Manager', }] },
    { value: ROLE_TYPE.FIELD_COORDINATOR, label: 'Field Coordinator', reporting_manager: [{ value: ROLE_TYPE.SUPER_VISOR, label: 'Supervisor', }] },
];

export const validateAdminForm = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    verification_id_type: Yup.string().required('Verification type is required'),
    verification_id: Yup.string().required('Verification id is required'),
    role: Yup.string().required('User role is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long'),
    phone_number: Yup.string().required('Phone number is required').min(10, 'Phone number must be exactly 10 digits'),
});

export const validateFamilyHeadForm = Yup.object().shape({
    name: Yup.string().required('Head of family is required'),
    aadhar: Yup.string().required('Aadhar Number is required'),
    govtId: Yup.string().required('Government id type is required'),
});

export const validateVillageForm = Yup.object().shape({
    village_name: Yup.string().required('Village name is required'),
    village_id: Yup.string().required('Village id is required'),
});

export const validateMemForm = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    govtId: Yup.string().required('Government id type is required'),
    aadhar: Yup.string().required('Aadhar is required'),
});


export const getRoleLabel = (role) => roleOptions.find(({ value }) => value === role)?.label || '';
export const getRoleValue = (role) => roleOptions.find(({ label }) => label === role)?.value || '';

export const setUpperLevelParams = (role) => {
    const roleMapping = {
        [ROLE_TYPE.ASSISTANT_STATE_COORDINATOR]: 'State Coordinator',
        [ROLE_TYPE.ZONAL_MANAGER]: 'Assistant State Coordinator',
        [ROLE_TYPE.SUPER_VISOR]: 'Zonal Manager',
        [ROLE_TYPE.FIELD_COORDINATOR]: 'Supervisor',
    };
    return roleMapping[role] || '';
};

export const setLowerLevelParams = (role) => {
    const roleMapping = {
        [ROLE_TYPE.STATE_COORDINATOR]: 'Assistant State Coordinator',
        [ROLE_TYPE.ASSISTANT_STATE_COORDINATOR]: 'Zonal Manager',
        [ROLE_TYPE.ZONAL_MANAGER]: 'Supervisor',
        [ROLE_TYPE.SUPER_VISOR]: 'Field Coordinator',
    };
    return roleMapping[role] || '';
};

export const getUserDataByRole = async (queryParams, successCallBack) => {
    try {
        const params = {
            user_type: setLowerLevelParams(queryParams?.role_type),
            ...queryParams,
        }
        delete params?.role_type;
        const response = await defaultInstance.get(API_ENDPOINTS.USER_LIST, { params: params });
        if (response?.data?.success) {
            const list = response?.data?.data?.length > 0 ? response?.data?.data : []
            list?.map((item) => {
                item.is_open = false;
                item.is_checked = false;
                return item;
            });
            successCallBack(list);
        }
    } catch (error) {
        console.error("Error fetching user data:", error);
    }
}

export const getFilterQuery = (data) => {

    const queryParams = {
        from_date: data?.from_date || moment().subtract(1, 'years').format('YYYY-MM-DD'),
        to_date: data?.to_date || moment().format('YYYY-MM-DD'),
        search_term: data?.search_term || '',
        page_limit: data?.page_limit || 400,
        skip_count: data?.skip_count || 0,
        status: data?.status == "all" ? "" : data?.status ? data?.status : 1,
        role_type: data?.role_type || '',
        village: data?.village || '',
        district: data?.district || '',
        health_facility: data?.health_facility || '',
        risk_score: data?.risk_score || '',
        case_of_htn: data?.case_of_htn || '',
        case_of_dm: data?.case_of_dm || '',
        suspected_oral_cancer: data?.suspected_oral_cancer || '',
        suspected_breast_cancer: data?.suspected_breast_cancer || '',
        cervical_cancer: data?.cervical_cancer || '',
        known_cvd: data?.known_cvd || '',
        history_of_stroke: data?.history_of_stroke || '',
        known_ckd: data?.known_ckd || '',
        cataract_assessment_result: data?.cataract_assessment_result || '',
        difficulty_hearing: data?.difficulty_hearing || '',
        leprosy: data?.leprosy || '',
        abhaid_status: data?.abhaid_status || '',
        sex: data?.sex || '',
        age: data?.age || '',
        alcohol_use: data?.alcohol_use || '',
        disability: data?.disability || '',
    }

    const queryString = new URLSearchParams(queryParams).toString();

    return queryString
}
export const getScreeningFilterQuery = (data) => {

    const queryParams = {
        from_date: data?.from_date || moment().subtract(1, 'years').format('YYYY-MM-DD'),
        to_date: data?.to_date || moment().format('YYYY-MM-DD'),
        search_term: data?.search_term || '',
        page_limit: data?.page_limit || 4000,
        skip_count: data?.skip_count || 0,
        role_type: data?.role_type || '',
    }

    const queryString = new URLSearchParams(queryParams).toString();

    return queryString
}

export const districtFilter = (data) => {
    const queryParams = {
        from_date: data?.from_date || moment('2024-08-01', 'YYYY-MM-DD').format('YYYY-MM-DD'),
        to_date: data?.to_date || moment('2025-02-11', 'YYYY-MM-DD').format('YYYY-MM-DD'),
    }
    return queryParams
}

export const getDashboardFilterQuery = (data) => {

    const queryParams = {
        from_date: data?.from_date || moment().subtract(1, 'years').format('YYYY-MM-DD'),
        to_date: data?.to_date || moment().format('YYYY-MM-DD'),
        search_term: data?.search_term || '',
        page_limit: data?.page_limit || 4000,
        skip_count: data?.skip_count || 0,
        role_type: data?.role_type || '',
        village: data?.village || '',
        district: data?.district || '',
        health_facility: data?.health_facility || '',
    }

    const queryString = new URLSearchParams(queryParams).toString();

    return queryString
}

export const riskScore = [
    { label: 'Select', value: "" },
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
    { label: 8, value: 8 },
]

export const yesNoOptions = [
    { label: 'Select', value: "" },
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
]

export const viaResultOptions = [
    { label: 'Select', value: "" },
    { label: 'Positive', value: 'Positive' },
    { label: 'Negative', value: 'Negative' },
]

export const AbhaIdStatus = [
    { label: 'Select', value: "" },
    { label: 'None', value: "None" },
    { label: 'Created', value: 'Created' },
    { label: 'Linked', value: 'Linked' },
]

export const occupationalExposure = [
    { label: 'Select', value: "" },
    { label: 'No', value: "No" },
    { label: 'Crop residue burning', value: 'Crop residue burning' },
    { label: 'Burning of garbage/leaves', value: 'Burning of garbage/leaves' },
    { label: 'Working in industries with smoke, gas, and dust exposure', value: 'Working in industries with smoke, gas, and dust exposure' },
]

export const typeOfFuelUsedForCooking = [
    { label: 'Select', value: "" },
    { label: 'Firewood', value: "Firewood" },
    { label: 'Crop Residue', value: "Crop Residue" },
    { label: 'Cow dung cake', value: "Cow dung cake" },
    { label: 'Coal', value: "Coal" },
    { label: 'Kerosene', value: "Kerosene" },
    { label: 'LPG', value: "LPG" },
]

export const sex = [
    { label: 'Select', value: "" },
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
    { label: 'Other', value: 'O' },
]

export const mentalHealthProblem = [
    { label: 'Select', value: "" },
    { label: 'Depression', value: 'Depression' },
    { label: 'Alcohol dependence', value: 'Alcohol dependence' },
    { label: 'Common Mental Health', value: 'Common Mental Health' },
    { label: 'No', value: 'No' },
]

export const age = [
    { label: 'Select', value: "" },
    { label: '18-29 Years', value: '18-29 years' },
    { label: '30-39 Years', value: '30-39 years' },
    { label: '40-49 Years', value: '40-49 years' },
    { label: '50-59 Years', value: '50-59 years' },
    { label: '60 years or above', value: '60 years or above' },
]
export const tobaccoUse = [
    { label: 'Select', value: "" },
    { label: 'Never', value: 'Never' },
    { label: 'Used to consume in the past/ Sometimes now', value: 'Used to consume in the past/ Sometimes now' },
    { label: 'Daily', value: 'Daily' },
]

export const waistCircumference = [
    { label: 'Select', value: "" },
    { label: '90 cm or less', value: '90 cm or less' },
    { label: '91-100 cm', value: '91-100 cm' },
    { label: 'More than 100 cm', value: 'More than 100 cm' },
]

export const physicalActivity = [
    { label: 'Select', value: "" },
    { label: 'At least 150 minutes in a week', value: 'At least 150 minutes in a week' },
    { label: 'Less than 150 minutes in a week', value: 'Less than 150 minutes in a week' },
]

export const feeling = [
    { value: "", label: "Select" },
    { value: "Not at all", label: "Not at all" },
    { value: "Several days", label: "Several days" },
    { value: "More than half the day", label: "More than half the day" },
    { value: "Nearly every day", label: "Nearly every day" }
]

export const htnOptions = [
    { label: 'Select', value: "" },
    { label: 'Yes and on treatment', value: 'yes and on treatment' },
    { label: 'Yes and not on treatment', value: 'yes and on treatment' },
    { label: 'No', value: 'No' },
]

export const knowCkdOptions = [
    { label: 'Select', value: "" },
    { label: 'Yes, on treatment', value: 'Yes, on treatment' },
    { label: 'Yes, not on treatment', value: 'Yes, not on treatment' },
    { label: 'No', value: 'No' },
]

export const heartSound = [
    { label: 'Select', value: "" },
    { label: 'Normal', value: 'Normal' },
    { label: 'Abnormal', value: 'Abnormal' },
    { label: 'Not Done', value: 'Not Done' },
]

export const cataract = [
    { label: 'Select', value: "" },
    { label: 'Suspected', value: 'Suspected' },
    { label: 'Not Suspected', value: 'Not Suspected' },
]

export const identifier = [
    { label: 'Select Identifier', value: "" },
    { label: 'ABHA ID', value: 'ABHA' },
    { label: 'Aadhar Card', value: 'Aadhar' },
    { label: 'Voter ID', value: 'Voter' },
]

export const allParameters = [
    { label: "ID", value: "fm_id" },
    { label: "Field Coordinator Name", value: "field_coordinator_name" },
    { label: "Head of Family Name", value: "head_of_family" },
    { label: "Family Member's Name", value: "pi_name" },
    { label: "District", value: "district" },
    { label: "Health Facility", value: "health_facility" },
    { label: "Village", value: "village", type: 'village' },
    { label: "Screening Date", value: "screening_date", type: 'date' },
    { label: "Identifier", value: "pi_identifier", },
    { label: "Card Number", value: "pi_card_number", },
    { label: "Date of Birth", value: "pi_dob", type: 'date' },
    { label: "Sex", value: "pi_sex", },
    { label: "Telephone Number", value: "pi_tel_no", },
    { label: "Address", value: "pi_address" },
    { label: "State Health Insurance", value: "pi_state_health_insurance", },
    { label: "State Health Insurance Remark", value: "pi_state_health_insurance_remark" },
    { label: "Disability", value: "pi_disability", },
    { label: "Disability Remark", value: "pi_disability_remark" },
    { label: "Height", value: "height" },
    { label: "Weight", value: "weight" },
    { label: "BMI", value: "bmi" },
    { label: "Temperature", value: "temperature" },
    { label: "SpO2", value: "spO2" },
    { label: "Pulse", value: "pulse" },
    { label: "Case of Hypertension", value: "case_of_htn" },
    { label: "Action for High Blood Pressure", value: "action_high_bp" },
    { label: "Referral Center for Hypertension", value: "referral_center_htn" },
    { label: "Upper Blood Pressure", value: "upper_bp" },
    { label: "Lower Blood Pressure", value: "lower_bp" },
    { label: "Case of Diabetes", value: "case_of_dm" },
    { label: "Action for High Blood Sugar", value: "action_high_bs" },
    { label: "Referral Center for Diabetes", value: "referral_center_dm" },
    { label: "Fasting Blood Sugar", value: "fasting_blood_sugar" },
    { label: "Post-Prandial Blood Sugar", value: "post_prandial_blood_sugar" },
    { label: "Random Blood Sugar", value: "random_blood_sugar" },
    { label: "Age", value: "age", },
    { label: "Tobacco Use", value: "tobacco_use" },
    { label: "Alcohol Use", value: "alcohol_use" },
    { label: "Waist (Female)", value: "waist_female" },
    { label: "Waist (Male)", value: "waist_male" },
    { label: "Physical Activity", value: "physical_activity" },
    { label: "Family History of Diabetes", value: "family_diabetes_history" },
    { label: "Risk Score", value: "risk_score" },
    { label: "Known Oral Cancer Case", value: "oc_known_case" },
    { label: "Persistent Ulcer", value: "persistent_ulcer" },
    { label: "Persistent Patch", value: "persistent_patch" },
    { label: "Difficulty Chewing", value: "difficulty_chewing" },
    { label: "Difficulty Opening Mouth", value: "difficulty_opening_mouth" },
    { label: "Growth in Mouth", value: "growth_in_mouth" },
    { label: "Swelling in Neck", value: "swelling_in_neck" },
    { label: "Suspected Oral Cancer", value: "suspected_oral_cancer" },
    { label: "Known Breast Cancer Case", value: "bc_known_case" },
    { label: "Lump in Breast", value: "lump_in_breast" },
    { label: "Blood-Stained Discharge", value: "blood_stained_discharge" },
    { label: "Change in Shape", value: "change_in_shape" },
    { label: "Constant Pain or Swelling", value: "constant_pain_or_swelling" },
    { label: "Redness or Ulcer", value: "redness_or_ulcer" },
    { label: "Suspected Breast Cancer", value: "suspected_breast_cancer" },
    { label: "Known Cervical Cancer Case", value: "cc_known_case" },
    { label: "Bleeding Between Periods", value: "bleeding_between_periods" },
    { label: "Bleeding After Menopause", value: "bleeding_after_menopause" },
    { label: "Bleeding After Intercourse", value: "bleeding_after_intercourse" },
    { label: "Foul-Smelling Discharge", value: "foul_smelling_discharge" },
    { label: "VIA Appointment Date", value: "via_appointment_date" },
    { label: "VIA Result", value: "via_result" },
    { label: "Known Cardiovascular Disease Case", value: "cvd_known_case" },
    { label: "Heart Sound", value: "heart_sound" },
    { label: "Symptom", value: "symptom" },
    { label: "CVD Date", value: "cvd_date" },
    { label: "Suspected Cardiovascular Disease", value: "suspected_cvd" },
    { label: "CVD Teleconsultation", value: "cvd_teleconsultation" },
    { label: "CVD Referral", value: "cvd_referral" },
    { label: "CVD Referral Centre", value: "cvd_referral_centre" },
    { label: "History of Stroke", value: "history_of_stroke" },
    { label: "Stroke Date", value: "stroke_date" },
    { label: "Present Condition", value: "present_condition" },
    { label: "Stroke Sign Action", value: "stroke_sign_action" },
    { label: "Referral Center Name", value: "referral_center_name" },
    { label: "Known CKD Case", value: "known_ckd" },
    { label: "History of CKD Stone", value: "history_ckd_stone" },
    { label: "Age Above 50", value: "age_above_50" },
    { label: "Hypertension Patient", value: "hypertension_patient" },
    { label: "Diabetes Patient", value: "diabetes_patient" },
    { label: "Anemia Patient", value: "anemia_patient" },
    { label: "History of Stroke (CKD)", value: "history_of_stroke_ckd" },
    { label: "Swelling in Face or Leg", value: "swelling_face_leg" },
    { label: "History of NSAIDs Use", value: "history_nsaids" },
    { label: "CKD Risk Score", value: "ckd_risk_score" },
    { label: "Risk Assessment", value: "risk_assessment" },
    { label: "Known CRD Case", value: "known_case_crd" },
    { label: "CRD Specify", value: "crd_specify" },
    { label: "Occupational Exposure", value: "occupational_exposure" },
    { label: "Cooking Fuel Type", value: "cooking_fuel_type" },
    { label: "Chest Sound", value: "chest_sound" },
    { label: "Chest Sound Action", value: "chest_sound_action" },
    { label: "Referral Center Name (Chest)", value: "referral_center_name_ct" },
    { label: "COPD Confirmed", value: "copd_confirmed" },
    { label: "COPD Confirmation Date", value: "copd_confirmation_date" },
    { label: "Shortness of Breath", value: "shortness_of_breath" },
    { label: "Coughing More Than 2 Weeks", value: "coughing_more_than_2_weeks" },
    { label: "Blood in Sputum", value: "blood_in_sputum" },
    { label: "Fever More Than 2 Weeks", value: "fever_more_than_2_weeks" },
    { label: "Night Sweats", value: "night_sweats" },
    { label: "Taking Anti-TB Drugs", value: "taking_anti_tb_drugs" },
    { label: "Family History of TB", value: "family_tb_history" },
    { label: "History of TB", value: "history_of_tb" },
    { label: "Cloudy or Blurred Vision", value: "cloudy_blurred_vision" },
    { label: "Pain or Redness", value: "pain_or_redness" },
    { label: "Cataract Assessment Result", value: "cataract_assessment_result" },
    { label: "Difficulty Hearing", value: "difficulty_hearing" },
    { label: "Hypopigmented Patch", value: "hypopigmented_patch" },
    { label: "Recurrent Ulceration", value: "recurrent_ulceration" },
    { label: "Clawing of Fingers", value: "clawing_of_fingers" },
    { label: "Inability to Close Eyelid", value: "inability_to_close_eyelid" },
    { label: "Difficulty Holding Objects", value: "difficulty_holding_objects" },
    { label: "Unsteady Walking", value: "unsteady_walking" },
    { label: "Physical Disability", value: "physical_disability" },
    { label: "Help from Others", value: "help_from_others" },
    { label: "Forget Names", value: "forget_names" },
    { label: "Little Interest or Pleasure", value: "little_interest_or_pleasure" },
    { label: "Feeling Down or Depressed", value: "feeling_down_or_depressed" },
    { label: "Mental Health Score", value: "mental_health_score" },
    { label: "Mental Health Problem", value: "mental_health_problem" },
    { label: "History of Fits", value: "history_of_fits" },
    { label: "Other Mental Disorder", value: "other_mental_disorder" },
    { label: "Brief Intervention Given", value: "brief_intervention_given" },
    { label: "Intervention Type", value: "intervention_type" },
    { label: "Major NCD Detected", value: "major_ncd_detected" },
    { label: "Any Other Disease Detected", value: "any_other_disease_detected" },
    { label: "Known Case of DM/HTN", value: "known_case_dm_htn", },
    { label: "Teleconsultation", value: "teleconsultation" },
    { label: "Prescription Given", value: "prescription_given" },
    { label: "Other Advices", value: "other_advices" },
    { label: "Remarks", value: "remarks" },
    { label: "ABHA ID Status", value: "abha_id_status" },
];

export const inputFields = [
    { label: "Name", key: "pi_name", type: 'text', required: false, options: [] },
    { label: "Identifier", key: "pi_identifier", type: 'select', options: identifier, required: false },
    { label: "Card Number", key: "pi_card_number", type: 'number', required: false, options: [] },
    { label: "Date of Birth", key: "pi_dob", type: 'date', required: false, options: [] },
    { label: "Sex", key: "pi_sex", type: 'select', options: sex, required: false },
    { label: "Phone Number", key: "pi_tel_no", type: 'number', required: false, options: [] },
    { label: "Address", key: "pi_address", type: 'text', required: false, options: [] },
    { label: "Health Insurance (State/Government/Private)", key: "pi_state_health_insurance", type: 'select', options: yesNoOptions, required: false },
    { label: "Disability", key: "pi_disability", type: 'select', options: yesNoOptions, required: false },
    { label: "Height (cm) *", key: "height", type: 'text', required: true, options: [] },
    { label: "Weight (kg) *", key: "weight", type: 'text', required: true, options: [] },
    { label: "BMI *", key: "bmi", type: 'text', required: true, options: [] },
    { label: "Temperature (°F) *", key: "temperature", type: 'text', required: true, options: [] },
    { label: "SpO2 (%) *", key: "spO2", type: 'text', required: true, options: [] },
    { label: "Pulse (bpm) *", key: "pulse", type: 'text', required: true, options: [] },
    { label: "Known case of HTN *", key: "case_of_htn", type: 'select', options: htnOptions, required: true },
    { label: "Upper BP (mmHg) *", key: "upper_bp", type: 'text', required: true, options: [] },
    { label: "Lower BP (mmHg) *", key: "lower_bp", type: 'text', required: true, options: [] },
    { label: "Known case of DM *", key: "case_of_dm", type: 'select', required: true, options: htnOptions },
    { label: "Fasting Blood Sugar (mg/dL)", key: "fasting_blood_sugar", type: 'text', required: false, options: [] },
    { label: "Post Prandial Blood Sugar (mg/dL)", key: "post_prandial_blood_sugar", type: 'text', required: false, options: [] },
    { label: "Random Blood Sugar (mg/dL)", key: "random_blood_sugar", type: 'text', required: false, options: [] },
    { label: "Age *", key: "age", type: 'select', required: true, options: age },
    { label: "Tobacco Use *", key: "tobacco_use", type: 'select', required: true, options: tobaccoUse },
    { label: "Alcohol Consumption *", key: "alcohol_use", type: 'select', required: true, options: yesNoOptions },
    { label: "Waist Circumference (Male) *", key: "waist_male", type: 'select', required: true, options: waistCircumference },
    { label: "Physical Activity *", key: "physical_activity", type: 'select', required: true, options: physicalActivity },
    { label: "Family History of Diabetes *", key: "family_diabetes_history", type: 'select', required: true, options: yesNoOptions },
    { label: "Risk Score *", key: "risk_score", type: 'select', required: true, options: riskScore },

    // { label: "Known Case *", key: "known_case", type: 'select', required: true, options: htnOptions },

    { label: "Persistent Ulcer *", key: "persistent_ulcer", type: 'select', required: true, options: yesNoOptions },
    { label: "Persistent Patch *", key: "persistent_patch", type: 'select', required: true, options: yesNoOptions },
    { label: "Difficulty Chewing *", key: "difficulty_chewing", type: 'select', required: true, options: yesNoOptions },
    { label: "Difficulty Opening Mouth *", key: "difficulty_opening_mouth", type: 'select', required: true, options: yesNoOptions },
    { label: "Growth in Mouth *", key: "growth_in_mouth", type: 'select', required: true, options: yesNoOptions },

    // { label: "Sudden change in voice *", key: "sudden_change_in_voice", type: 'select', required: true, options: yesNoOptions },

    { label: "Suspected Oral Cancer *", key: "suspected_oral_cancer", type: 'select', required: true, options: yesNoOptions },
    { label: "Lump in Breast *", key: "lump_in_breast", type: 'select', required: true, options: yesNoOptions },
    { label: "Blood-Stained Discharge *", key: "blood_stained_discharge", type: 'select', required: true, options: yesNoOptions },
    { label: "Change in Shape *", key: "change_in_shape", type: 'select', required: true, options: yesNoOptions },
    { label: "Constant Pain or Swelling *", key: "constant_pain_or_swelling", type: 'select', required: true, options: yesNoOptions },
    { label: "Redness or Ulcer *", key: "redness_or_ulcer", type: 'select', required: true, options: yesNoOptions },
    { label: "Suspected Breast Cancer *", key: "suspected_breast_cancer", type: 'select', required: true, options: yesNoOptions },
    { label: "Heart Sound *", key: "heart_sound", type: 'select', required: true, options: heartSound },
    { label: "Symptom *", key: "symptom", type: 'select', required: true, options: yesNoOptions },
    { label: "CVD Date *", key: "cvd_date", type: 'date', required: true, options: [] },
    { label: "Suspected CVD *", key: "suspected_cvd", type: 'select', required: true, options: yesNoOptions },
    { label: "History of Stroke *", key: "history_of_stroke", type: 'select', required: true, options: yesNoOptions },
    { label: "Known case of CKD *", key: "known_ckd", type: 'select', required: true, options: knowCkdOptions },
    { label: "History of CKD/Stone *", key: "history_ckd_stone", type: 'select', required: true, options: yesNoOptions },
    { label: "Age Above 50 *", key: "age_above_50", type: 'select', required: true, options: yesNoOptions },
    { label: "Hypertension Patient *", key: "hypertension_patient", type: 'select', required: true, options: yesNoOptions },
    { label: "Diabetes Patient *", key: "diabetes_patient", type: 'select', required: true, options: yesNoOptions },
    { label: "Anemia Patient *", key: "anemia_patient", type: 'select', required: true, options: yesNoOptions },
    { label: "Swelling on Face and Leg *", key: "swelling_face_leg", type: 'select', required: true, options: yesNoOptions },
    { label: "History of NSAIDS *", key: "history_nsaids", type: 'select', required: true, options: yesNoOptions },
    { label: "Risk Assessment *", key: "risk_assessment", type: 'text', required: true, options: [] },
    { label: "Known case of chronic respiratory diseases (ASTHMA/COPD/OTHERS) *", key: "known_case_crd", type: 'select', required: true, options: yesNoOptions },
    { label: "Occupational Exposure *", key: "occupational_exposure", type: 'select', required: true, options: occupationalExposure },
    { label: "Type of Fuel Used for Cooking *", key: "cooking_fuel_type", type: 'select', required: true, options: typeOfFuelUsedForCooking },
    { label: "Shortness of Breath *", key: "shortness_of_breath", type: 'select', required: true, options: yesNoOptions },
    { label: "Coughing for More Than 2 Weeks *", key: "coughing_more_than_2_weeks", type: 'select', required: true, options: yesNoOptions },
    { label: "Blood in Sputum *", key: "blood_in_sputum", type: 'select', required: true, options: yesNoOptions },
    { label: "Fever for More Than 2 Weeks *", key: "fever_more_than_2_weeks", type: 'select', required: true, options: yesNoOptions },
    { label: "Night Sweats *", key: "night_sweats", type: 'select', required: true, options: yesNoOptions },
    { label: "Are you currently taking anti-TB drugs? *", key: "taking_anti_tb_drugs", type: 'select', required: true, options: yesNoOptions },
    { label: "Anyone in family currently suffering from TB *", key: "family_tb_history", type: 'select', required: true, options: yesNoOptions },
    { label: "History of TB *", key: "history_of_tb", type: 'select', required: true, options: yesNoOptions },
    { label: "Do you have cloudy or blurred vision? *", key: "cloudy_blurred_vision", type: 'select', required: true, options: yesNoOptions },
    { label: "Pain or redness in eyes lasting for more than a week *", key: "pain_or_redness", type: 'select', required: true, options: yesNoOptions },
    { label: "Cataract Assessment Result *", key: "cataract_assessment_result", type: 'select', required: true, options: cataract },
    { label: "Do you have difficulty in hearing? *", key: "difficulty_hearing", type: 'select', required: true, options: yesNoOptions },

    // { label: "Hypopigmented or discolored lesion(s) with loss of sensation *", key: "hypopigmented_or_discolored_lesions_loss_of_sensation", type: 'select', required: true, options: yesNoOptions },

    { label: "Recurrent ulceration on palm or sole *", key: "recurrent_ulceration", type: 'select', required: true, options: yesNoOptions },
    { label: "Clawing of fingers or tingling/numbness in hands/feet *", key: "clawing_of_fingers", type: 'select', required: true, options: yesNoOptions },
    { label: "Inability to close eyelid *", key: "inability_to_close_eyelid", type: 'select', required: true, options: yesNoOptions },
    { label: "Difficulty in holding objects or weakness in feet *", key: "difficulty_holding_objects", type: 'select', required: true, options: yesNoOptions },
    { label: "Do you feel unsteady while standing or walking? *", key: "unsteady_walking", type: 'select', required: true, options: yesNoOptions },
    { label: "Are you suffering from any physical disability? *", key: "physical_disability", type: 'select', required: true, options: yesNoOptions },

    // { label: "Do you need help with everyday activities? *", key: "need_help_with_activities", type: 'select', required: true, options: yesNoOptions },
    // { label: "Do you forget names of near ones or your address? *", key: "forget_names_or_address", type: 'select', required: true, options: yesNoOptions },

    { label: "Little interest or pleasure in doing things? *", key: "little_interest_or_pleasure", type: 'select', required: true, options: feeling },
    { label: "Feeling down, depressed, or hopeless? *", key: "feeling_down_or_depressed", type: 'select', required: true, options: feeling },
    { label: "Mental Health Score:", key: "mental_health_score", type: 'text', required: true, options: [] },
    { label: "Mental Health problem detected through the questionnaire *", key: "mental_health_problem", type: 'select', required: true, options: mentalHealthProblem },
    { label: "History of fits *", key: "history_of_fits", type: 'select', required: true, options: yesNoOptions },
    { label: "Other mental disorder *", key: "other_mental_disorder", type: 'select', required: true, options: yesNoOptions },
    { label: "Brief intervention given? *", key: "brief_intervention_given", type: 'select', required: true, options: yesNoOptions },
    { label: "Major NCD Detected", key: "major_ncd_detected", type: 'text', required: true, options: [] },
    { label: "Any Other Disease Detected", key: "any_other_disease_detected", type: 'text', required: true, options: [] },
    { label: "Known Case of DM with HTN", key: "known_case_dm_htn", type: 'text', required: true, options: [] },
    { label: "Teleconsultation", key: "cvd_teleconsultation", type: 'select', required: true, options: yesNoOptions },
    { label: "Prescription Given", key: "prescription_given", type: 'select', required: true, options: yesNoOptions },
    { label: "Other Advices", key: "other_advices", type: 'text', required: true, options: [] },
    { label: "Remarks", key: "remarks", type: 'text', required: true, options: [] },
    { label: "ABHA ID Status", key: "abha_id_status", type: 'select', required: true, options: AbhaIdStatus },
    { label: "Screening Date", key: "screening_date", type: 'date', required: true, options: [] },

    { label: "Head of Family", key: "head_of_family", type: 'select', select_type: 'custom', required: true, options: [] },
    { label: "Name of Asha", key: "asha_name", type: 'text', required: true, options: [] },
    { label: "District", key: "district", type: 'text', required: true, options: [] },
    { label: "Health Facility", key: "health_facility", type: 'text', required: true, options: [] },
    // { label: "Midori Staff", key: "midori_staff_name", type: 'text', required: true, options: [] },
    { label: "Name of MO/CHO/ANM", key: "mo_mpw_cho_anu_name", type: 'text', required: true, options: [] },
    { label: "Village", key: "village", type: 'village', required: true, options: [] },
]

export const femaleCervicalAssessments = [
    { label: "Known Case *", key: "cc_known_case", type: 'select', required: true, options: htnOptions },
    { label: "Bleeding Between Periods", key: "bleeding_between_periods", type: 'select', required: true, options: yesNoOptions },
    { label: "Bleeding After Menopause", key: "bleeding_after_menopause", type: 'select', required: true, options: yesNoOptions },
    { label: "Bleeding After Intercourse", key: "bleeding_after_intercourse", type: 'select', required: true, options: yesNoOptions },
    { label: "Foul Smelling Discharge", key: "foul_smelling_discharge", type: 'select', required: true, options: yesNoOptions },
    { label: "VIA Appointment Date", key: "via_appointment_date", type: 'date', required: true, options: [] },
    { label: "VIA Result", key: "via_result", type: 'select', required: true, options: viaResultOptions },
]

export const formFields = {
    "pi_name": "",
    "pi_identifier": "",
    "pi_card_number": "",
    "pi_dob": "",
    "pi_sex": "",
    "pi_tel_no": "",
    "pi_address": "",
    "pi_state_health_insurance": "",
    "pi_disability": "",
    "height": "",
    "weight": "",
    "bmi": "",
    "temperature": "",
    "spO2": "",
    "pulse": "",
    "case_of_htn": "",
    "upper_bp": "",
    "lower_bp": "",
    "case_of_dm": "",
    "fasting_blood_sugar": "",
    "post_prandial_blood_sugar": "",
    "random_blood_sugar": "",
    "age": "",
    "tobacco_use": "",
    "alcohol_use": "",
    "waist_male": "",
    "physical_activity": "",
    "family_diabetes_history": "",
    "risk_score": "",
    "persistent_ulcer": "",
    "persistent_patch": "",
    "difficulty_chewing": "",
    "difficulty_opening_mouth": "",
    "growth_in_mouth": "",
    "suspected_oral_cancer": "",
    "lump_in_breast": "",
    "blood_stained_discharge": "",
    "change_in_shape": "",
    "constant_pain_or_swelling": "",
    "redness_or_ulcer": "",
    "suspected_breast_cancer": "",
    "heart_sound": "",
    "symptom": "",
    "cvd_date": "",
    "suspected_cvd": "",
    "history_of_stroke": "",
    "known_ckd": "",
    "history_ckd_stone": "",
    "age_above_50": "",
    "hypertension_patient": "",
    "diabetes_patient": "",
    "anemia_patient": "",
    "swelling_face_leg": "",
    "history_nsaids": "",
    "risk_assessment": "",
    "known_case_crd": "",
    "occupational_exposure": "",
    "cooking_fuel_type": "",
    "shortness_of_breath": "",
    "coughing_more_than_2_weeks": "",
    "blood_in_sputum": "",
    "fever_more_than_2_weeks": "",
    "night_sweats": "",
    "taking_anti_tb_drugs": "",
    "family_tb_history": "",
    "history_of_tb": "",
    "cloudy_blurred_vision": "",
    "pain_or_redness": "",
    "cataract_assessment_result": "",
    "difficulty_hearing": "",
    "recurrent_ulceration": "",
    "clawing_of_fingers": "",
    "inability_to_close_eyelid": "",
    "difficulty_holding_objects": "",
    "unsteady_walking": "",
    "physical_disability": "",
    "little_interest_or_pleasure": "",
    "feeling_down_or_depressed": "",
    "mental_health_score": "",
    "mental_health_problem": "",
    "history_of_fits": "",
    "other_mental_disorder": "",
    "brief_intervention_given": "",
    "major_ncd_detected": "",
    "any_other_disease_detected": "",
    "known_case_dm_htn": "",
    "cvd_teleconsultation": "",
    "prescription_given": "",
    "other_advices": "",
    "remarks": "",
    "abha_id_status": "",
    "screening_date": "",
    "screening_status": 1,
    "head_of_family": '',
    "asha_name": '',
    "district": '',
    "health_facility": '',
    // "midori_staff_name": '',
    "mo_mpw_cho_anu_name": '',
    "village": '',
    "fc_id": '',
    "cc_known_case": '',
    "bleeding_between_periods": "",
    "bleeding_after_menopause": "",
    "bleeding_after_intercourse": "",
    "foul_smelling_discharge": "",
    "via_appointment_date": "",
    "via_result": "",
}

export const defaultDistrict = [
    { "district_count": 0, "label": "Bishnupur", "value": "Bishnupur" },
    { "district_count": 0, "label": "Chandel", "value": "Chandel" },
    { "district_count": 0, "label": "Churachandpur", "value": "Churachandpur" },
    { "district_count": 0, "label": "Imphal East", "value": "Imphal East" },
    { "district_count": 0, "label": "Imphal West", "value": "Imphal West" },
    { "district_count": 0, "label": "Jiribam", "value": "Jiribam" },
    { "district_count": 0, "label": "Kakching", "value": "Kakching" },
    { "district_count": 0, "label": "Kamjong", "value": "Kamjong" },
    { "district_count": 0, "label": "Kangpokpi", "value": "Kangpokpi" },
    { "district_count": 0, "label": "Noney", "value": "Noney" },
    { "district_count": 0, "label": "Pherzawl", "value": "Pherzawl" },
    { "district_count": 0, "label": "Senapati", "value": "Senapati" },
    { "district_count": 0, "label": "Tamenglong", "value": "Tamenglong" },
    { "district_count": 0, "label": "Tengnoupal", "value": "Tengnoupal" },
    { "district_count": 0, "label": "Thoubal", "value": "Thoubal" },
    { "district_count": 0, "label": "Ukhrul", "value": "Ukhrul" }
]


export const handleInputChangeWithMaxLength = (e, maxLength, callback) => {
    const { value } = e.target;
    const stringValue = value?.toString();
    if (stringValue?.length <= maxLength || !stringValue) {
        callback(e);
    }
}

export const removeTrailingZeros = (input) => {
    if (!input) {
        return ""
    }
    const tempString = input?.toString()
    if (!tempString?.includes('.')) {
        return tempString;
    }
    return tempString?.replace(/(\.0+$|(?<=\.\d*[^0])0+$)/, "");
};


export const helperFucn = () => {
    const data = healthFacilitiesUpdate1.map((item, idx) => {
        return {
            ...item,
            id: idx + 1,
            type: item?.facility_name?.split(' ')?.[0],
        }
    })
    const result = data.map(item => {
        const yes_month = [];
        const no_month = [];
        for (const [key, value] of Object.entries(item)) {
            if (/^[A-Za-z]{3}-\d{2}$/.test(key)) {
                if (value === "YES") {
                    yes_month.push(key);
                } else if (value === "NO") {
                    no_month.push(key);
                }
            }
        }
        return {
            district: item?.district?.trim(''),
            facility_name: item?.facility_name,
            id: item?.id,
            type: item?.type,
            yes_month,
            no_month
        };
    });

    return result
}


export const healthFacilities = [
    { "id": 1, "district": "Bishnupur", "facility_name": "CHC Nambol", "type": "CHC" },
    { "id": 2, "district": "Bishnupur", "facility_name": "PHC Kumbi", "type": "PHC" },
    { "id": 3, "district": "Bishnupur", "facility_name": "PHC KWAKTA", "type": "PHC" },
    { "id": 4, "district": "Bishnupur", "facility_name": "PHC LEIMAPOKPAM", "type": "PHC" },
    { "id": 5, "district": "Bishnupur", "facility_name": "PHC Nachou", "type": "PHC" },
    { "id": 6, "district": "Bishnupur", "facility_name": "PHC NINGTHOUKHONG", "type": "PHC" },
    { "id": 7, "district": "Bishnupur", "facility_name": "PHC Oinam", "type": "PHC" },
    { "id": 8, "district": "Bishnupur", "facility_name": "PHSC Ithing Khola", "type": "AAM" },
    { "id": 9, "district": "Bishnupur", "facility_name": "PHSC Ithing Khunjao", "type": "AAM" },
    { "id": 10, "district": "Bishnupur", "facility_name": "PHSC Keibul", "type": "AAM" },
    { "id": 11, "district": "Bishnupur", "facility_name": "PHSC keinou", "type": "AAM" },
    { "id": 12, "district": "Bishnupur", "facility_name": "PHSC Khoijuman", "type": "AAM" },
    { "id": 13, "district": "Bishnupur", "facility_name": "PHSC Khordak Ichin", "type": "AAM" },
    { "id": 14, "district": "Bishnupur", "facility_name": "PHSC LEIMARAM", "type": "AAM" },
    { "id": 15, "district": "Bishnupur", "facility_name": "PHSC NACHOU", "type": "HWC" },
    { "id": 16, "district": "Bishnupur", "facility_name": "PHSC PHUBALA", "type": "AAM" },
    { "id": 17, "district": "Bishnupur", "facility_name": "PHSC SANJENBAM", "type": "AAM" },
    { "id": 18, "district": "Bishnupur", "facility_name": "PHSC Thinungei", "type": "AAM" },
    { "id": 19, "district": "Bishnupur", "facility_name": "PHSC UTLOU", "type": "AAM" },
    { "id": 127, "district": "Bishnupur", "facility_name": "PHSC Pukhrambam", "type": "HWC" },
    { "id": 20, "district": "Chandel", "facility_name": "CHC Chakpi Karong", "type": "CHC" },
    { "id": 21, "district": "Chandel", "facility_name": "District Hospital Chandel", "type": "DH" },
    { "id": 22, "district": "Chandel", "facility_name": "PHC Sajik Tampak", "type": "PHC" },
    { "id": 23, "district": "Imphal East", "facility_name": "CHC Sagolmang", "type": "CHC" },
    { "id": 24, "district": "Imphal East", "facility_name": "PHC Akampat", "type": "PHC" },
    { "id": 25, "district": "Imphal East", "facility_name": "PHC Andro", "type": "PHC" },
    { "id": 26, "district": "Imphal East", "facility_name": "PHC Bashikhong", "type": "PHC" },
    { "id": 27, "district": "Imphal East", "facility_name": "PHC Heingang", "type": "PHC" },
    { "id": 28, "district": "Imphal East", "facility_name": "PHC Keirao Makting", "type": "PHC" },
    { "id": 29, "district": "Imphal East", "facility_name": "PHC Lamlai", "type": "PHC" },
    { "id": 30, "district": "Imphal East", "facility_name": "PHC Sawombung", "type": "PHC" },
    { "id": 31, "district": "Imphal East", "facility_name": "PHC Yaingangpokpi", "type": "PHC" },
    { "id": 32, "district": "Imphal East", "facility_name": "PHC Yambem", "type": "PHC" },
    { "id": 33, "district": "Imphal East", "facility_name": "PHSC Achanbigei", "type": "AAM" },
    { "id": 34, "district": "Imphal East", "facility_name": "PHSC ANGTHA", "type": "AAM" },
    { "id": 35, "district": "Imphal East", "facility_name": "PHSC Chanam Sandrok", "type": "AAM" },
    { "id": 36, "district": "Imphal East", "facility_name": "PHSC Chingkhu Sambei", "type": "AAM" },
    { "id": 37, "district": "Imphal East", "facility_name": "PHSC Heikrumakhong", "type": "AAM" },
    { "id": 38, "district": "Imphal East", "facility_name": "PHSC HUIKAP", "type": "AAM" },
    { "id": 39, "district": "Imphal East", "facility_name": "PHSC IRILBUNG", "type": "AAM" },
    { "id": 40, "district": "Imphal East", "facility_name": "PHSC KAIRANG MUSLIM", "type": "AAM" },
    { "id": 41, "district": "Imphal East", "facility_name": "PHSC KANGLA SIPHAI", "type": "AAM" },
    { "id": 42, "district": "Imphal East", "facility_name": "PHSC Keikol", "type": "AAM" },
    { "id": 43, "district": "Imphal East", "facility_name": "PHSC KEIRANG MUSLIM", "type": "AAM" },
    { "id": 44, "district": "Imphal East", "facility_name": "PHSC Keirao Wangkhem", "type": "AAM" },
    { "id": 45, "district": "Imphal East", "facility_name": "PHSC Khabeisoi", "type": "AAM" },
    { "id": 46, "district": "Imphal East", "facility_name": "PHSC KHURAI LAIWANGMA", "type": "AAM" },
    { "id": 47, "district": "Imphal East", "facility_name": "PHSC KHURAI SAJOR LEIKAI", "type": "AAM" },
    { "id": 48, "district": "Imphal East", "facility_name": "PHSC KITNA PANUNG", "type": "AAM" },
    { "id": 49, "district": "Imphal East", "facility_name": "PHSC KIYAMGEI KHAGI", "type": "AAM" },
    { "id": 50, "district": "Imphal East", "facility_name": "PHSC KONGBA", "type": "AAM" },
    { "id": 51, "district": "Imphal East", "facility_name": "PHSC Kyamgei Muslim", "type": "AAM" },
    { "id": 52, "district": "Imphal East", "facility_name": "PHSC Laipham khunou", "type": "AAM" },
    { "id": 53, "district": "Imphal East", "facility_name": "PHSC LUWANGSANGBAM", "type": "AAM" },
    { "id": 54, "district": "Imphal East", "facility_name": "PHSC NAOREM CHAPROU", "type": "AAM" },
    { "id": 55, "district": "Imphal East", "facility_name": "PHSC Ningomthong kitnapanung", "type": "AAM" },
    { "id": 56, "district": "Imphal East", "facility_name": "PHSC NINGOMTHONGJAO", "type": "AAM" },
    { "id": 57, "district": "Imphal East", "facility_name": "PHSC NONGPOK KEITHELMANBI", "type": "AAM" },
    { "id": 58, "district": "Imphal East", "facility_name": "PHSC Nongren", "type": "AAM" },
    { "id": 59, "district": "Imphal East", "facility_name": "PHSC Seijang", "type": "AAM" },
    { "id": 60, "district": "Imphal East", "facility_name": "PHSC SEKTA", "type": "AAM" },
    { "id": 61, "district": "Imphal East", "facility_name": "PHSC Takhel", "type": "AAM" },
    { "id": 62, "district": "Imphal East", "facility_name": "PHSC Tellou Chana", "type": "AAM" },
    { "id": 63, "district": "Imphal East", "facility_name": "PHSC THAMBALKHONG", "type": "AAM" },
    { "id": 64, "district": "Imphal East", "facility_name": "PHSC Top Chingtha", "type": "AAM" },
    { "id": 65, "district": "Imphal East", "facility_name": "PHSC Ucheckon", "type": "AAM" },
    { "id": 66, "district": "Imphal East", "facility_name": "PHSC Ucheckon Laikon", "type": "AAM" },
    { "id": 67, "district": "Imphal East", "facility_name": "PHSC UCHEKKON", "type": "AAM" },
    { "id": 68, "district": "Imphal East", "facility_name": "PHSC URUP MUSLIM AWANG LEIKEI", "type": "AAM" },
    { "id": 69, "district": "Imphal East", "facility_name": "PHSC Urup Salangpham", "type": "AAM" },
    { "id": 70, "district": "Imphal East", "facility_name": "PHSC WAITON", "type": "AAM" },
    { "id": 71, "district": "Imphal East", "facility_name": "UPHC Kshetrigao", "type": "UPHC" },
    { "id": 72, "district": "Imphal East", "facility_name": "UPHC Mantripukhri", "type": "UPHC" },
    { "id": 73, "district": "Imphal East", "facility_name": "UPHC MINUTHONG", "type": "UPHC" },
    { "id": 74, "district": "Imphal East", "facility_name": "UPHC Sangaipat", "type": "UPHC" },
    { "id": 75, "district": "Imphal East", "facility_name": "UPHSC Hatta Golapati", "type": "UPHC" },
    { "id": 76, "district": "Imphal East", "facility_name": "UPHSC PALACE COMPOUND", "type": "UPHC" },
    { "id": 77, "district": "Imphal East", "facility_name": "UPHSC Soibam Leikai", "type": "UPHC" },
    { "id": 78, "district": "Imphal West", "facility_name": "CHC AWANG SEKMAI", "type": "CHC" },
    { "id": 79, "district": "Imphal West", "facility_name": "CHC Khumbong", "type": "CHC" },
    { "id": 80, "district": "Imphal West", "facility_name": "CHC Wangoi", "type": "CHC" },
    { "id": 81, "district": "Imphal West", "facility_name": "Konjeng Leikai Dispensory", "type": "AAM" },
    { "id": 82, "district": "Imphal West", "facility_name": "PHC Kakwa", "type": "PHC" },
    { "id": 83, "district": "Imphal West", "facility_name": "PHC Khonghampat", "type": "PHC" },
    { "id": 84, "district": "Imphal West", "facility_name": "PHC Khurkhul", "type": "PHC" },
    { "id": 85, "district": "Imphal West", "facility_name": "PHC Mayang Imphal", "type": "PHC" },
    { "id": 86, "district": "Imphal West", "facility_name": "PHC Mekola", "type": "PHC" },
    { "id": 87, "district": "Imphal West", "facility_name": "PHC Phayeng", "type": "PHC" },
    { "id": 88, "district": "Imphal West", "facility_name": "PHC Salam", "type": "PHC" },
    { "id": 89, "district": "Imphal West", "facility_name": "PHC Samurou", "type": "PHC" },
    { "id": 90, "district": "Imphal West", "facility_name": "PHC Sekmaijin", "type": "PHC" },
    { "id": 91, "district": "Imphal West", "facility_name": "PHSC AWANG JIRI", "type": "AAM" },
    { "id": 92, "district": "Imphal West", "facility_name": "PHSC Awang khunou", "type": "AAM" },
    { "id": 93, "district": "Imphal West", "facility_name": "PHSC AWANG WABAGAI", "type": "AAM" },
    { "id": 94, "district": "Imphal West", "facility_name": "PHSC Bamdiar", "type": "AAM" },
    { "id": 95, "district": "Imphal West", "facility_name": "PHSC Bengoon", "type": "AAM" },
    { "id": 96, "district": "Imphal West", "facility_name": "PHSC Changangei", "type": "AAM" },
    { "id": 97, "district": "Imphal West", "facility_name": "PHSC Chirai", "type": "AAM" },
    { "id": 98, "district": "Imphal West", "facility_name": "PHSC HAORANG SABAL", "type": "AAM" },
    { "id": 99, "district": "Imphal West", "facility_name": "PHSC Heigrujam", "type": "AAM" },
    { "id": 100, "district": "Imphal West", "facility_name": "PHSC Heinoukhongnembi", "type": "AAM" },
    { "id": 101, "district": "Imphal West", "facility_name": "PHSC Hiyangthang", "type": "AAM" },
    { "id": 102, "district": "Imphal West", "facility_name": "PHSC IRAM SIPHAI", "type": "AAM" },
    { "id": 103, "district": "Imphal West", "facility_name": "PHSC Irom Meijrao", "type": "AAM" },
    { "id": 104, "district": "Imphal West", "facility_name": "PHSC Kadangband", "type": "AAM" },
    { "id": 105, "district": "Imphal West", "facility_name": "PHSC KANGLATOMBI", "type": "AAM" },
    { "id": 106, "district": "Imphal West", "facility_name": "PHSC Kangmong", "type": "AAM" },
    { "id": 107, "district": "Imphal West", "facility_name": "PHSC Khabi Thangtek", "type": "AAM" },
    { "id": 108, "district": "Imphal West", "facility_name": "PHSC Khamnam Bazaar", "type": "AAM" },
    { "id": 109, "district": "Imphal West", "facility_name": "PHSC KOKCHAI", "type": "AAM" },
    { "id": 110, "district": "Imphal West", "facility_name": "PHSC Komlakhong", "type": "AAM" },
    { "id": 111, "district": "Imphal West", "facility_name": "PHSC Konjeng Leikai Dispensory", "type": "AAM" },
    { "id": 112, "district": "Imphal West", "facility_name": "PHSC Konthoujam", "type": "AAM" },
    { "id": 113, "district": "Imphal West", "facility_name": "PHSC Kwakeithel Heinoukhongnembi", "type": "AAM" },
    { "id": 114, "district": "Imphal West", "facility_name": "PHSC LAMDENG", "type": "AAM" },
    { "id": 115, "district": "Imphal West", "facility_name": "PHSC Langthabal kunja", "type": "AAM" },
    { "id": 116, "district": "Imphal West", "facility_name": "PHSC MALOM TULIYAIMA", "type": "AAM" },
    { "id": 117, "district": "Imphal West", "facility_name": "PHSC Mayang Imphal", "type": "AAM" },
    { "id": 118, "district": "Imphal West", "facility_name": "PHSC Mayang Langjing", "type": "AAM" },
    { "id": 119, "district": "Imphal West", "facility_name": "PHSC MONGSANGEI", "type": "AAM" },
    { "id": 120, "district": "Imphal West", "facility_name": "PHSC Mutum Phibou", "type": "AAM" },
    { "id": 121, "district": "Imphal West", "facility_name": "PHSC Naoriya Pakhanglakpa", "type": "AAM" },
    { "id": 122, "district": "Imphal West", "facility_name": "PHSC Ningombam", "type": "AAM" },
    { "id": 123, "district": "Imphal West", "facility_name": "PHSC NONGCHUP KAMENG", "type": "AAM" },
    { "id": 124, "district": "Imphal West", "facility_name": "PHSC Nongchup Keithelmanbi", "type": "AAM" },
    { "id": 125, "district": "Imphal West", "facility_name": "PHSC OINAM SAWOMBUNG", "type": "AAM" },
    { "id": 126, "district": "Imphal West", "facility_name": "PHSC Phumlou", "type": "AAM" },
    { "id": 128, "district": "Imphal West", "facility_name": "PHSC Sagolaband Lamkhai", "type": "AAM" },
    { "id": 129, "district": "Imphal West", "facility_name": "PHSC SAMUSHANG", "type": "AAM" },
    { "id": 130, "district": "Imphal West", "facility_name": "PHSC Sangaiprou", "type": "AAM" },
    { "id": 131, "district": "Imphal West", "facility_name": "PHSC TAKYEL KHONGBAN", "type": "AAM" },
    { "id": 132, "district": "Imphal West", "facility_name": "PHSC TAOBUNGKHOK", "type": "AAM" },
    { "id": 133, "district": "Imphal West", "facility_name": "PHSC Tendongyan", "type": "AAM" },
    { "id": 134, "district": "Imphal West", "facility_name": "PHSC WAISHEL MAPAL", "type": "AAM" },
    { "id": 135, "district": "Imphal West", "facility_name": "PHSC Yumnam Huidrom", "type": "AAM" },
    { "id": 136, "district": "Imphal West", "facility_name": "PHSC Yurembam", "type": "AAM" },
    { "id": 137, "district": "Imphal West", "facility_name": "UPHC Iroisemba", "type": "UPHC" },
    { "id": 138, "district": "Imphal West", "facility_name": "UPHC Kwakeithel", "type": "UPHC" },
    { "id": 139, "district": "Imphal West", "facility_name": "UPHC Langol Tarung", "type": "UPHC" },
    { "id": 140, "district": "Imphal West", "facility_name": "UPHC Sagolband", "type": "UPHC" },
    { "id": 141, "district": "Imphal West", "facility_name": "UPHC Singjamei", "type": "UPHC" },
    { "id": 142, "district": "Imphal West", "facility_name": "UPHSC Uripok", "type": "UPHC" },
    { "id": 143, "district": "Jiribam", "facility_name": "CHC Jiribam", "type": "CHC" },
    { "id": 144, "district": "Jiribam", "facility_name": "PHSC Gularthol", "type": "HWC" },
    { "id": 145, "district": "Kakching", "facility_name": "CHC SUGNU", "type": "CHC" },
    { "id": 146, "district": "Kakching", "facility_name": "PHC HIYANGLAM", "type": "PHC" },
    { "id": 147, "district": "Kakching", "facility_name": "PHC KAKCHING KHUNOU", "type": "PHC" },
    { "id": 148, "district": "Kakching", "facility_name": "PHC Wangoo", "type": "PHC" },
    { "id": 149, "district": "Kakching", "facility_name": "PHC WANGOO LAIPHAM", "type": "PHC" },
    { "id": 150, "district": "Kakching", "facility_name": "PHSC Arong Tera", "type": "AAM" },
    { "id": 151, "district": "Kakching", "facility_name": "PHSC ELANGKHANGPOKPI", "type": "AAM" },
    { "id": 152, "district": "Kakching", "facility_name": "PHSC Irengband", "type": "AAM" },
    { "id": 153, "district": "Kakching", "facility_name": "PHSC KAKCHING", "type": "AAM" },
    { "id": 154, "district": "Kakching", "facility_name": "PHSC KEIRAK", "type": "AAM" },
    { "id": 155, "district": "Kakching", "facility_name": "PHSC KEIRAK KANGJEIBUNG", "type": "AAM" },
    { "id": 156, "district": "Kakching", "facility_name": "PHSC LANGMEIDONG", "type": "AAM" },
    { "id": 157, "district": "Kakching", "facility_name": "PHSC MANTAK", "type": "AAM" },
    { "id": 158, "district": "Kakching", "facility_name": "PHSC MAYENGLAMJAO", "type": "AAM" },
    { "id": 159, "district": "Kakching", "facility_name": "PHSC NUNGOO CHAIREN", "type": "AAM" },
    { "id": 160, "district": "Kakching", "facility_name": "PHSC PANGALTABI", "type": "AAM" },
    { "id": 161, "district": "Kakching", "facility_name": "PHSC SORA", "type": "AAM" },
    { "id": 162, "district": "Kakching", "facility_name": "PHSC THONGAM", "type": "AAM" },
    { "id": 163, "district": "Kakching", "facility_name": "PHSC WABAGAI", "type": "AAM" },
    { "id": 164, "district": "Kakching", "facility_name": "PHSC Waikhong", "type": "AAM" },
    { "id": 165, "district": "Kakching", "facility_name": "PHSC Wangkhem", "type": "AAM" },
    { "id": 166, "district": "Kakching", "facility_name": "UPHC KAKCHING", "type": "UPHC" },
    { "id": 167, "district": "Kamjong", "facility_name": "PHSC KAMJONG", "type": "HWC" },
    { "id": 168, "district": "Kamjong", "facility_name": "PHSC MAWAI", "type": "HWC" },
    { "id": 169, "district": "Kamjong", "facility_name": "PHSC SHINGCHA", "type": "HWC" },
    { "id": 170, "district": "Kangpokpi", "facility_name": "CHC KANGPOKPI", "type": "CHC" },
    { "id": 171, "district": "Kangpokpi", "facility_name": "District Hospital Kangpokpi", "type": "DH" },
    { "id": 172, "district": "Senapati", "facility_name": "CHC Tadubi", "type": "CHC" },
    { "id": 173, "district": "Senapati", "facility_name": "District Hospital Senapati", "type": "DH" },
    { "id": 174, "district": "Senapati", "facility_name": "PHSC Karong", "type": "HWC" },
    { "id": 175, "district": "Senapati", "facility_name": "PHSC Koide", "type": "HWC" },
    { "id": 176, "district": "Senapati", "facility_name": "PHSC Lairouching", "type": "HWC" },
    { "id": 177, "district": "Senapati", "facility_name": "PHSC Maram Khullen", "type": "HWC" },
    { "id": 178, "district": "Senapati", "facility_name": "PHSC Ramlong", "type": "HWC" },
    { "id": 179, "district": "Senapati", "facility_name": "PHSC Shajouba", "type": "HWC" },
    { "id": 180, "district": "Senapati", "facility_name": "PHSC Tobumai", "type": "HWC" },
    { "id": 181, "district": "Senapati", "facility_name": "PHSC Willong", "type": "HWC" },
    { "id": 182, "district": "Tamenglong", "facility_name": "District Hospital Tamenglong", "type": "DH" },
    { "id": 183, "district": "Tengnoupal", "facility_name": "PHC Aimol Tampak", "type": "PHC" },
    { "id": 184, "district": "Tengnoupal", "facility_name": "PHC PALLEL", "type": "PHC" },
    { "id": 185, "district": "Tengnoupal", "facility_name": "PHC Rilram centre", "type": "PHC" },
    { "id": 186, "district": "Tengnoupal", "facility_name": "PHC Saivom", "type": "PHC" },
    { "id": 187, "district": "Tengnoupal", "facility_name": "PHSC Khubung Khullen", "type": "HWC" },
    { "id": 188, "district": "Tengnoupal", "facility_name": "PHSC Khulsaibung", "type": "HWC" },
    { "id": 189, "district": "Tengnoupal", "facility_name": "PHSC KHUNBI", "type": "HWC" },
    { "id": 190, "district": "Tengnoupal", "facility_name": "PHSC Machi", "type": "HWC" },
    { "id": 191, "district": "Tengnoupal", "facility_name": "PHSC Sita", "type": "HWC" },
    { "id": 192, "district": "Thoubal", "facility_name": "CHC HAOREIBI", "type": "CHC" },
    { "id": 193, "district": "Thoubal", "facility_name": "CHC HEIROK", "type": "CHC" },
    { "id": 194, "district": "Thoubal", "facility_name": "CHC YAIRIPOK", "type": "CHC" },
    { "id": 195, "district": "Thoubal", "facility_name": "PHC Charangpat", "type": "PHC" },
    { "id": 196, "district": "Thoubal", "facility_name": "PHC KHOIROM", "type": "PHC" },
    { "id": 197, "district": "Thoubal", "facility_name": "PHC KHONGJOM", "type": "PHC" },
    { "id": 198, "district": "Thoubal", "facility_name": "PHC Leishangthem", "type": "PHC" },
    { "id": 199, "district": "Thoubal", "facility_name": "PHC LILONG", "type": "PHC" },
    { "id": 200, "district": "Thoubal", "facility_name": "PHC NONGPOK SEKMAI", "type": "PHC" },
    { "id": 201, "district": "Thoubal", "facility_name": "PHC SANGAIYUMPHAM", "type": "PHC" },
    { "id": 202, "district": "Thoubal", "facility_name": "PHC WANGJING", "type": "PHC" },
    { "id": 203, "district": "Thoubal", "facility_name": "PHSC ATHOKPAM", "type": "AAM" },
    { "id": 204, "district": "Thoubal", "facility_name": "PHSC CHANDRAKHONG", "type": "AAM" },
    { "id": 205, "district": "Thoubal", "facility_name": "PHSC CHAOBOK KABUI", "type": "AAM" },
    { "id": 206, "district": "Thoubal", "facility_name": "PHSC HAOKHA", "type": "AAM" },
    { "id": 207, "district": "Thoubal", "facility_name": "PHSC HAOREIBI MAYAI LEIKAI", "type": "AAM" },
    { "id": 208, "district": "Thoubal", "facility_name": "PHSC HAOREIBI TUREL AHANBI", "type": "AAM" },
    { "id": 209, "district": "Thoubal", "facility_name": "PHSC IRONG CHESABA", "type": "AAM" },
    { "id": 210, "district": "Thoubal", "facility_name": "PHSC IRONG KHUNOU", "type": "AAM" },
    { "id": 211, "district": "Thoubal", "facility_name": "PHSC IRONG THOKCHOM", "type": "AAM" },
    { "id": 212, "district": "Thoubal", "facility_name": "PHSC Karam Haoreibi", "type": "AAM" },
    { "id": 213, "district": "Thoubal", "facility_name": "PHSC KEKRU", "type": "AAM" },
    { "id": 214, "district": "Thoubal", "facility_name": "PHSC KHANGABOK", "type": "AAM" },
    { "id": 215, "district": "Thoubal", "facility_name": "PHSC KHEKMAN", "type": "AAM" },
    { "id": 216, "district": "Thoubal", "facility_name": "PHSC KIYAM LITANPOK", "type": "AAM" },
    { "id": 217, "district": "Thoubal", "facility_name": "PHSC KSHETRI LEIKAI", "type": "AAM" },
    { "id": 218, "district": "Thoubal", "facility_name": "PHSC LANGATHEL", "type": "AAM" },
    { "id": 219, "district": "Thoubal", "facility_name": "PHSC LEIRONGTHEL MALOM", "type": "AAM" },
    { "id": 220, "district": "Thoubal", "facility_name": "PHSC Litan Makhong", "type": "AAM" },
    { "id": 221, "district": "Thoubal", "facility_name": "PHSC MOIJING", "type": "AAM" },
    { "id": 222, "district": "Thoubal", "facility_name": "PHSC NUNGEI", "type": "AAM" },
    { "id": 223, "district": "Thoubal", "facility_name": "PHSC PHUNDREI", "type": "AAM" },
    { "id": 224, "district": "Thoubal", "facility_name": "PHSC SALUNGPHAM", "type": "AAM" },
    { "id": 225, "district": "Thoubal", "facility_name": "PHSC TEKCHAM", "type": "AAM" },
    { "id": 226, "district": "Thoubal", "facility_name": "PHSC TENTHA", "type": "AAM" },
    { "id": 227, "district": "Thoubal", "facility_name": "PHSC THOKCHOM BENGI", "type": "AAM" },
    { "id": 228, "district": "Thoubal", "facility_name": "PHSC THOUBAL BAZAR", "type": "AAM" },
    { "id": 229, "district": "Thoubal", "facility_name": "PHSC THOUBAL KHUNOU", "type": "AAM" },
    { "id": 230, "district": "Thoubal", "facility_name": "PHSC THOUBAL NINGOMBAM", "type": "AAM" },
    { "id": 231, "district": "Thoubal", "facility_name": "PHSC THOUBAL WANGMATABA", "type": "AAM" },
    { "id": 232, "district": "Thoubal", "facility_name": "PHSC TUREL AHANBI Ubakthong", "type": "AAM" },
    { "id": 233, "district": "Thoubal", "facility_name": "PHSC Uchiwa", "type": "AAM" },
    { "id": 234, "district": "Thoubal", "facility_name": "PHSC UKHONGSHANG", "type": "AAM" },
    { "id": 235, "district": "Thoubal", "facility_name": "PHSC WAITHOU", "type": "AAM" },
    { "id": 236, "district": "Thoubal", "facility_name": "UPHC PHOUDEN", "type": "UPHC" },
    { "id": 237, "district": "Thoubal", "facility_name": "UPHC THOUBAL BAZAR", "type": "UPHC" },
    { "id": 238, "district": "Thoubal", "facility_name": "UPHSC Kshetrileikai Tomjing Makhong", "type": "UPHC" }
]

export const healthFacilitiesUpdate = [
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM Ithing Khola",
        "id": 1,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM Ithing Khunjao",
        "id": 2,
        "type": "AAM",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM Keibul",
        "id": 3,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM keinou",
        "id": 4,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM KHA THINUNGEI",
        "id": 5,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM Khoijuman",
        "id": 6,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM Khordak Ichin",
        "id": 7,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM LEIMARAM",
        "id": 8,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM NACHOU",
        "id": 9,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM PHUBALA",
        "id": 10,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM PUKHRAMBAM",
        "id": 11,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM Thinungei",
        "id": 12,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM TOUBUL",
        "id": 13,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "AAM UTLOU",
        "id": 14,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "CHC Nambol",
        "id": 15,
        "type": "CHC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "CHC NAMBOL ",
        "id": 16,
        "type": "CHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "HWC NACHOU",
        "id": 17,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "HWC Pukhrambam",
        "id": 18,
        "type": "HWC",
        "yes_month": [
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "KUMBI PHC",
        "id": 19,
        "type": "KUMBI",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC Kumbi",
        "id": 20,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC KWAKTA",
        "id": 21,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC LEIMAPOKPAM",
        "id": 22,
        "type": "PHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC Nachou",
        "id": 23,
        "type": "PHC",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC NINGTHOUKHONG",
        "id": 24,
        "type": "PHC",
        "yes_month": [
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC Oinam",
        "id": 25,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "CHC Chakpi Karong",
        "id": 26,
        "type": "CHC",
        "yes_month": [
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "CHC Chakpikarong",
        "id": 27,
        "type": "CHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "District Hospital Chandel",
        "id": 28,
        "type": "District",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "HWC Khubung Khullen",
        "id": 29,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "PHC Sajik Tampak",
        "id": 30,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM  HUIKAP",
        "id": 31,
        "type": "AAM",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM  KHURAI SAJOR LEIKAI",
        "id": 32,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM  UCHEKON LAIKON",
        "id": 33,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM  URUP SALANGPHAM",
        "id": 34,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Achanbigei",
        "id": 35,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Angtha",
        "id": 36,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM CHANAM SANDROK",
        "id": 37,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM CHINGKHU SAMBEI",
        "id": 38,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Heikrumakhong",
        "id": 39,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM IRILBUNG",
        "id": 40,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM IRILBUNG ",
        "id": 41,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KAIRANG MUSLIM",
        "id": 42,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KANGLA SIPHAI",
        "id": 43,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Keibi",
        "id": 44,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KEIKOL",
        "id": 45,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Keirao Wangkhem",
        "id": 46,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KHABEISOI",
        "id": 47,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KHURAI HEINOUMAKHONG",
        "id": 48,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KHURAI LAIWANGMA",
        "id": 49,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KHURAI SAJOR LEIKAI",
        "id": 50,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KIYAMGEI MUSLIM",
        "id": 51,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM KONGBA",
        "id": 52,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Laipham khunou",
        "id": 53,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM LUWANGSANGBAM",
        "id": 54,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM NINGOMTHONGJAO",
        "id": 55,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Nonggren",
        "id": 56,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Nongren",
        "id": 57,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM OKSU",
        "id": 58,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM SANJENBAM",
        "id": 59,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Seijang",
        "id": 60,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM SEKTA",
        "id": 61,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Takhel",
        "id": 62,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Tellou Chana",
        "id": 63,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM THAMBALKHONG",
        "id": 64,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Top Chingtha",
        "id": 65,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM Ucheckon Laikon",
        "id": 66,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM UCHEKKON",
        "id": 67,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "AAM WAITON",
        "id": 68,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "CHC Sagolmang",
        "id": 69,
        "type": "CHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Achanbigei",
        "id": 70,
        "type": "HWC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC ANGTHA",
        "id": 71,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "Hwc Chanam Sandrok",
        "id": 72,
        "type": "Hwc",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Chingkhu Sambei",
        "id": 73,
        "type": "HWC",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Heikrumakhong",
        "id": 74,
        "type": "HWC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC HUIKAP",
        "id": 75,
        "type": "HWC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC KAIRANG MUSLIM",
        "id": 76,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Keikol",
        "id": 77,
        "type": "HWC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC KEIRANG MUSLIM",
        "id": 78,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Khabeisoi",
        "id": 79,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC KHURAI SAJOR LEIKAI",
        "id": 80,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC KITNA PANUNG",
        "id": 81,
        "type": "HWC",
        "yes_month": [
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC KIYAMGEI KHAGI",
        "id": 82,
        "type": "HWC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC KONGBA",
        "id": 83,
        "type": "HWC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Kyamgei KhagI",
        "id": 84,
        "type": "HWC",
        "yes_month": [
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Kyamgei Muslim",
        "id": 85,
        "type": "HWC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Ningomthong kitnapanung",
        "id": 86,
        "type": "HWC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Sekta",
        "id": 87,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC THAMBALKHONG",
        "id": 88,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Ucheckon",
        "id": 89,
        "type": "HWC",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC URUP MUSLIM AWANG LEIKEI ",
        "id": 90,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "HWC Urup Salangpham",
        "id": 91,
        "type": "HWC",
        "yes_month": [
            "Sep-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "KEIRAO MAKTING PHC ",
        "id": 92,
        "type": "KEIRAO",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Akampat",
        "id": 93,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Andro",
        "id": 94,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Bashikhong",
        "id": 95,
        "type": "PHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Heingang",
        "id": 96,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Keirao Makting",
        "id": 97,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC KEIRAO MAKTING  ",
        "id": 98,
        "type": "PHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Lamlai",
        "id": 99,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC NONGPOK KEITHELMANBI",
        "id": 100,
        "type": "PHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Sawombung",
        "id": 101,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Yaingangpokpi",
        "id": 102,
        "type": "PHC",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC YAINGANGPOKPI ",
        "id": 103,
        "type": "PHC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC Yambem",
        "id": 104,
        "type": "PHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UAAM Hatta Golapati",
        "id": 105,
        "type": "UAAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UAAM PALACE COMPOUND",
        "id": 106,
        "type": "UAAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UAAM Soibam Leikai",
        "id": 107,
        "type": "UAAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC KIYAMGEI KHAGI",
        "id": 108,
        "type": "UPHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC Kshetrigao",
        "id": 109,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC MANTRI PUKHRI",
        "id": 110,
        "type": "UPHC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC Mantripukhri",
        "id": 111,
        "type": "UPHC",
        "yes_month": [
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC MANTRIPUKHRI ",
        "id": 112,
        "type": "UPHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC MINUTHONG",
        "id": 113,
        "type": "UPHC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC Sangaipat",
        "id": 114,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHSC SOIBAM LEIKAI",
        "id": 115,
        "type": "UPHSC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": " PHC Kakwa",
        "id": 116,
        "type": "",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM  AWANG JIRI",
        "id": 117,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM  UCHIWA",
        "id": 118,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM AWANG JIRI",
        "id": 119,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Awang khunou",
        "id": 120,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM AWANG WABAGAI",
        "id": 121,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Bamdiar",
        "id": 122,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Bengoon",
        "id": 123,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Changangei",
        "id": 124,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM CHIRAI",
        "id": 125,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM HAORANG SABAL",
        "id": 126,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM HAORANG SABAL DISPENSORY",
        "id": 127,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Heigrujam",
        "id": 128,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Heinoukhongnembi",
        "id": 129,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM HIYANGTHANG",
        "id": 130,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM IRAM SIPHAI",
        "id": 131,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Irom Meijrao",
        "id": 132,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KADANGBAN",
        "id": 133,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Kadangband",
        "id": 134,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Kadangband ",
        "id": 135,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KANGLATOMBI",
        "id": 136,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KANGLATONGBI",
        "id": 137,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Kangmong",
        "id": 138,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KARAM HAOREIBI",
        "id": 139,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Khabi Thangtek",
        "id": 140,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Khamnam Bazaar",
        "id": 141,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KHAMNAM BAZAR",
        "id": 142,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KHURAI LAIWANGMA",
        "id": 143,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KOKCHAI",
        "id": 144,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Komlakhong",
        "id": 145,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KONJENG LEIKAI DISPENSORY",
        "id": 146,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Konthoujam",
        "id": 147,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM KWAKEITHEL HEINOUKHONGMENBI",
        "id": 148,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Kwakeithel Heinoukhongnembi",
        "id": 149,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM LAMDENG",
        "id": 150,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Lamdeng ",
        "id": 151,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Lamdeng Mayai",
        "id": 152,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM LANGOL DISPENSORY",
        "id": 153,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Langthabal kunja",
        "id": 154,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM LAPHUPAT TERA",
        "id": 155,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM MAKLANG",
        "id": 156,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM MALOM TULIYAIMA",
        "id": 157,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Mayang Langjing",
        "id": 158,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM MONGSANGEI",
        "id": 159,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Mutum Phibou",
        "id": 160,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM NAOREM CHAPROU",
        "id": 161,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Ningombam",
        "id": 162,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM NONGCHUP KAMENG",
        "id": 163,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Nongchup Keithelmanbi",
        "id": 164,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM NONGPOK KEITHELMANBI",
        "id": 165,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Phumlou",
        "id": 166,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Sagolaband Lamkhai",
        "id": 167,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Sagolband Lamkhai",
        "id": 168,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM SAMUSHANG",
        "id": 169,
        "type": "AAM",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Sangaiprou",
        "id": 170,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Tabungkhok",
        "id": 171,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Takyel Khongbal",
        "id": 172,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM TAKYEL KHONGBAN",
        "id": 173,
        "type": "AAM",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM TAOBUNGKHOK",
        "id": 174,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Tendongyan",
        "id": 175,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Waisel Mapal",
        "id": 176,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM WAISHEL MAPAL",
        "id": 177,
        "type": "AAM",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM YUMNAM HUIDROM",
        "id": 178,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "AAM Yurembam",
        "id": 179,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC AWANG SEKMAI",
        "id": 180,
        "type": "CHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC Khumbong",
        "id": 181,
        "type": "CHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC SEKMAI",
        "id": 182,
        "type": "CHC",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC Wangoi",
        "id": 183,
        "type": "CHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HPHC Iroishemba",
        "id": 184,
        "type": "HPHC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC HAORANG SABAL DISPENSARY",
        "id": 185,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC KANGLATOMBI",
        "id": 186,
        "type": "HWC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC Kwakeithel Heinoukhongnembi",
        "id": 187,
        "type": "HWC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC Mayang Imphal",
        "id": 188,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC Phumlou",
        "id": 189,
        "type": "HWC",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC Tabungkhok",
        "id": 190,
        "type": "HWC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC Takyel Khongbal",
        "id": 191,
        "type": "HWC",
        "yes_month": [
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "HWC Uchiwa",
        "id": 192,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "Konjeng Leikai Dispensery",
        "id": 193,
        "type": "Konjeng",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "Konjeng Leikai Dispensory",
        "id": 194,
        "type": "Konjeng",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "LANGOL TARUNG",
        "id": 195,
        "type": "LANGOL",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Kakwa",
        "id": 196,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Khonghampat",
        "id": 197,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Khurkhul",
        "id": 198,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Mayang Imphal",
        "id": 199,
        "type": "PHC",
        "yes_month": [
            "Sep-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Mekola",
        "id": 200,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Phayeng",
        "id": 201,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Salam",
        "id": 202,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Samurou",
        "id": 203,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Sekmaijin",
        "id": 204,
        "type": "PHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC Sekmaijing",
        "id": 205,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC BENGOON",
        "id": 206,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Chirai",
        "id": 207,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Heigrujam",
        "id": 208,
        "type": "PHSC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Hiyangthang",
        "id": 209,
        "type": "PHSC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Iramsiphai",
        "id": 210,
        "type": "PHSC",
        "yes_month": [
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Karam Haoreibi",
        "id": 211,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KOKCHAI",
        "id": 212,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KOMLAKHONG",
        "id": 213,
        "type": "PHSC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KONTHOUJAM",
        "id": 214,
        "type": "PHSC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Kwakeithel Heinou Khongnembi",
        "id": 215,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Langthabal Kunja",
        "id": 216,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Malom Tuliyaima",
        "id": 217,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC MONGSANGEI",
        "id": 218,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC NAORIA PAKHANGLAKPA",
        "id": 219,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Naoriya Pakhanglakpa",
        "id": 220,
        "type": "PHSC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Samusang",
        "id": 221,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC SAMUSHANG",
        "id": 222,
        "type": "PHSC",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Takyel Khongbal",
        "id": 223,
        "type": "PHSC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Tendongyan",
        "id": 224,
        "type": "PHSC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Uchiwa",
        "id": 225,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Uchiwa ",
        "id": 226,
        "type": "PHSC",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC WAISHEL MAPAL",
        "id": 227,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC Yumnam Huidrom",
        "id": 228,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC YUREMBAM",
        "id": 229,
        "type": "PHSC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "Sub center chirai",
        "id": 230,
        "type": "Sub",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UAAM Uripok",
        "id": 231,
        "type": "UAAM",
        "yes_month": [
            "Nov-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC  KWAKEITHEL",
        "id": 232,
        "type": "UPHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC EROISEMBA",
        "id": 233,
        "type": "UPHC",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Iroisemba",
        "id": 234,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Iroishemba",
        "id": 235,
        "type": "UPHC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Kwakeithel",
        "id": 236,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Kwakeithel ",
        "id": 237,
        "type": "UPHC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Langol Tarung",
        "id": 238,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Sagolband",
        "id": 239,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Sagolband ",
        "id": 240,
        "type": "UPHC",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC Singjamei",
        "id": 241,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC THANGAL BAZAR",
        "id": 242,
        "type": "UPHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "JIRIBAM",
        "facility_name": "CHC Jiribam ",
        "id": 243,
        "type": "CHC",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "JIRIBAM",
        "facility_name": "PHSC Gularthol",
        "id": 244,
        "type": "PHSC",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "AAM KEIRAK",
        "id": 245,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "AAM keirak kangjeibung",
        "id": 246,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "AAM LANGMEIDONG",
        "id": 247,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "AAM MANTAK",
        "id": 248,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "AAM THONGAM",
        "id": 249,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "AAM THONGAM ",
        "id": 250,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "CHC SUGNU ",
        "id": 251,
        "type": "CHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "CHC SUGUNU",
        "id": 252,
        "type": "CHC",
        "yes_month": [
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC Arong Tera",
        "id": 253,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC ELANGKHANGPOKPI",
        "id": 254,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC Irengband",
        "id": 255,
        "type": "HWC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC KAKCHING ",
        "id": 256,
        "type": "HWC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC KEIRAK KANGJEIBUNG",
        "id": 257,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC MANTAK",
        "id": 258,
        "type": "HWC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC PANGALTABI",
        "id": 259,
        "type": "HWC",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC THONGAM",
        "id": 260,
        "type": "HWC",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC WABAGAI",
        "id": 261,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC WABAGAI ",
        "id": 262,
        "type": "HWC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "HWC Waikhong",
        "id": 263,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC HIYANGLAM",
        "id": 264,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC HIYANGLAM ",
        "id": 265,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC KAKCHING KHUNOU",
        "id": 266,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC PALLEL",
        "id": 267,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "phc wangoo",
        "id": 268,
        "type": "phc",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC WANGOO LAIPHAM",
        "id": 269,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC MAYENGLAMJAO",
        "id": 270,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC NUNGOO CHAIREN",
        "id": 271,
        "type": "PHSC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC Pangantabi",
        "id": 272,
        "type": "PHSC",
        "yes_month": [
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "SC SORA",
        "id": 273,
        "type": "SC",
        "yes_month": [
            "Aug-24",
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "UPHC  KAKCHING",
        "id": 274,
        "type": "UPHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "UPHC KAKCHING",
        "id": 275,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "UPHC KAKCHING ",
        "id": 276,
        "type": "UPHC",
        "yes_month": [
            "Aug-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAMJONG",
        "facility_name": "HWC MAWAI",
        "id": 277,
        "type": "HWC",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAMJONG",
        "facility_name": "PHSC KAMJONG",
        "id": 278,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAMJONG",
        "facility_name": "PHSC SHINGCHA",
        "id": 279,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KANGPOKPI",
        "facility_name": "CHC KANGPOKPI",
        "id": 280,
        "type": "CHC",
        "yes_month": [
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KANGPOKPI",
        "facility_name": "District Hospital Kangpokpi",
        "id": 281,
        "type": "District",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "Pherzawl",
        "facility_name": "CHC PARBUNG ",
        "id": 282,
        "type": "CHC",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "AAM MARAM KHUNOU",
        "id": 283,
        "type": "AAM",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "CHC Tadubi",
        "id": 284,
        "type": "CHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "District Hospital Senapati",
        "id": 285,
        "type": "District",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Karong",
        "id": 286,
        "type": "HWC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Koide",
        "id": 287,
        "type": "HWC",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Lairouching ",
        "id": 288,
        "type": "HWC",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Maram Khunou",
        "id": 289,
        "type": "HWC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Ramlong",
        "id": 290,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Shajouba ",
        "id": 291,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Tobumai ",
        "id": 292,
        "type": "HWC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC Willong",
        "id": 293,
        "type": "HWC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "PHSC Maram Khullen ",
        "id": 294,
        "type": "PHSC",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TAMENGLONG",
        "facility_name": "District Hospital Tamenglong",
        "id": 295,
        "type": "District",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": " HWC Machi ",
        "id": 296,
        "type": "",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": " PHC Rilram centre ",
        "id": 297,
        "type": "",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "AAM KHULSAIBUNG",
        "id": 298,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "HWC Khulsaibung",
        "id": 299,
        "type": "HWC",
        "yes_month": [
            "Dec-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "HWC Khunbi ",
        "id": 300,
        "type": "HWC",
        "yes_month": [
            "Nov-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHC Aimol Tampak",
        "id": 301,
        "type": "PHC",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHC Saivom",
        "id": 302,
        "type": "PHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHSC KHUNBI ",
        "id": 303,
        "type": "PHSC",
        "yes_month": [
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHSC Sita ",
        "id": 304,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM  ATHOKPAM",
        "id": 305,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM  CHAOBOK KABUI",
        "id": 306,
        "type": "AAM",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM  HAOKHA",
        "id": 307,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM  KIYAM LITANPOK",
        "id": 308,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM  THOUBAL KHUNOU",
        "id": 309,
        "type": "AAM",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM ATHOKPAM",
        "id": 310,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM CHANDRAKHONG",
        "id": 311,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM CHAOBOK KABUI",
        "id": 312,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM HAOKHA",
        "id": 313,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM HAOREIBI MAYAI LEIKAI",
        "id": 314,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM HAOREIBI TUREL AHANBI",
        "id": 315,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM HEIBONG MAKHONG",
        "id": 316,
        "type": "AAM",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM IRONG CHESABA",
        "id": 317,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM IRONG KHUNOU",
        "id": 318,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM IRONG THOKCHOM",
        "id": 319,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KEKRU",
        "id": 320,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KHANGABOK",
        "id": 321,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KHANGBOK",
        "id": 322,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KHEKMAN",
        "id": 323,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KIYAM LEITANPOK",
        "id": 324,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KIYAM LITANPOK",
        "id": 325,
        "type": "AAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM KSHETRI LEIKAI",
        "id": 326,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM LANGATHEL",
        "id": 327,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM LEIRONGTHEL MALOM",
        "id": 328,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM Litan Makhong",
        "id": 329,
        "type": "AAM",
        "yes_month": [
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM LITANMAKHONG",
        "id": 330,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM MOIJING",
        "id": 331,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Oct-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Nov-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM Ningombam",
        "id": 332,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM NUNGEI",
        "id": 333,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM OINAM SAWOMBUNG",
        "id": 334,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM PHUNDREI",
        "id": 335,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM SALUNGPHAM",
        "id": 336,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM TEKCHAM",
        "id": 337,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM TENTHA",
        "id": 338,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM THOKCHOM BENGI",
        "id": 339,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM THOUBAL BAZAR",
        "id": 340,
        "type": "AAM",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM THOUBAL KHUNOU",
        "id": 341,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM THOUBAL NINGOMBAM",
        "id": 342,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM THOUBAL WANGMATABA",
        "id": 343,
        "type": "AAM",
        "yes_month": [
            "Sep-24",
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM TOKCHOM BENGI",
        "id": 344,
        "type": "AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM TUREL AHANBI Ubakthong",
        "id": 345,
        "type": "AAM",
        "yes_month": [
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM UKHONGSANG",
        "id": 346,
        "type": "AAM",
        "yes_month": [
            "Oct-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM UKHONGSHANG",
        "id": 347,
        "type": "AAM",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM WAITHOU",
        "id": 348,
        "type": "AAM",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "AAM Wangkhem",
        "id": 349,
        "type": "AAM",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "CHC HAOREIBI",
        "id": 350,
        "type": "CHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "CHC HEIROK",
        "id": 351,
        "type": "CHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "CHC YAIRIPOK",
        "id": 352,
        "type": "CHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC Charangpat",
        "id": 353,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC KHOIROM",
        "id": 354,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC KHONGJOM",
        "id": 355,
        "type": "PHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC Leishangthem",
        "id": 356,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC LILONG",
        "id": 357,
        "type": "PHC",
        "yes_month": [
            "Oct-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Nov-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC NONGPOK SEKMAI",
        "id": 358,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC SANGAIYUMPHAM",
        "id": 359,
        "type": "PHC",
        "yes_month": [
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC WANGJING",
        "id": 360,
        "type": "PHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC YAIRIPOK",
        "id": 361,
        "type": "PHC",
        "yes_month": [
            "Sep-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC N/Sekmai",
        "id": 362,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC UKHONGSHANG",
        "id": 363,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC Ukongsang",
        "id": 364,
        "type": "PHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PWC LANGATHEL",
        "id": 365,
        "type": "PWC",
        "yes_month": [
            "Aug-24"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UAAM Kshetri Leikai Tomjin Makhong",
        "id": 366,
        "type": "UAAM",
        "yes_month": [
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UAAM Kshetrileikai Tomjing Makhong",
        "id": 367,
        "type": "UAAM",
        "yes_month": [
            "Oct-24",
            "Nov-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Dec-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "U-AAM TOMJIN MAKHONG",
        "id": 368,
        "type": "U-AAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UAAM Tomjing Makhong",
        "id": 369,
        "type": "UAAM",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHC Phoudel",
        "id": 370,
        "type": "UPHC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHC PHOUDEN",
        "id": 371,
        "type": "UPHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHC THOUBAL BAZAR",
        "id": 372,
        "type": "UPHC",
        "yes_month": [
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHSC TOMJIN MAKHONG",
        "id": 373,
        "type": "UPHSC",
        "yes_month": [
            "Feb-25"
        ],
        "no_month": [
            "Jan-24",
            "Feb-24",
            "Mar-24",
            "Apr-24",
            "May-24",
            "Jun-24",
            "Jul-24",
            "Aug-24",
            "Sep-24",
            "Oct-24",
            "Nov-24",
            "Dec-24",
            "Jan-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    }
]

export const midoriTeamList = [
    {
        "sl_no": 1,
        "district": "BISHNUPUR",
        "health_center": "PHSC ISHOK",
        "asha": "L.BASANTI DEVI-9366975760",
        "anm_cho": "L. LAKSHMI DEVI(CHO)-9612044418",
        "fc_teams": "Shyamchand"
    },
    {
        "sl_no": 2,
        "district": "BISHNUPUR",
        "health_center": "PHSC ITHING KHOLA",
        "asha": "P.SHAMA DEVI-7085796118",
        "anm_cho": "SHAKUNTALA.N(CHO)-9774263826",
        "fc_teams": "T.Jila"
    },
    {
        "sl_no": 3,
        "district": "BISHNUPUR",
        "health_center": "PHSC KEINOU",
        "asha": "A.BINA-9089561469",
        "anm_cho": "ASEM GOMTI DEVI(CHO)-9436428161",
        "fc_teams": "S.jemson"
    },
    {
        "sl_no": 4,
        "district": "BISHNUPUR",
        "health_center": "PHSC KHA THINUNGEI",
        "asha": "L.RANJITA DEVI-9615477140",
        "anm_cho": "K. REBIKA DEVI(CHO)-7085910404",
        "fc_teams": "Bala"
    },
    {
        "sl_no": 5,
        "district": "BISHNUPUR",
        "health_center": "PHSC KHOIJUMAN",
        "asha": "KH.LEIBAKLEIMA-9856897739",
        "anm_cho": "TH.RONIBALA DEVI(CHO)-8787789613",
        "fc_teams": "Rabichandra"
    },
    {
        "sl_no": 6,
        "district": "BISHNUPUR",
        "health_center": "PHSC LEIMARAM",
        "asha": "M. SUNI-8974042632",
        "anm_cho": "S. BABBY DEVI(CHO)-7005150355",
        "fc_teams": "Priyadarshini"
    },
    {
        "sl_no": 7,
        "district": "BISHNUPUR",
        "health_center": "PHSC NACHOU",
        "asha": "L.REBIKA-8014315834",
        "anm_cho": "TH.BIJETA DEVI(CHO)-9615453284",
        "fc_teams": "Sushitra  Sophia"
    },
    {
        "sl_no": 8,
        "district": "BISHNUPUR",
        "health_center": "PHSC NARANSHEINA",
        "asha": "M LATA -9089425846",
        "anm_cho": "SALAM ABITA (CHO)-9856685356",
        "fc_teams": "Sophia"
    },
    {
        "sl_no": 9,
        "district": "BISHNUPUR",
        "health_center": "PHSC NGAIKHONG KHULLEN",
        "asha": "K.BINA-9615263024",
        "anm_cho": "TH. DIANA(CHO)-9774771522",
        "fc_teams": "Priya"
    },
    {
        "sl_no": 10,
        "district": "BISHNUPUR",
        "health_center": "PHSC NGAIKHONG KHUNOU",
        "asha": "P.MAYABATI-9615823800",
        "anm_cho": "JOLLY.TH(CHO)-8787550885",
        "fc_teams": "Priya"
    },
    {
        "sl_no": 11,
        "district": "BISHNUPUR",
        "health_center": "PHSC PHUBALA",
        "asha": "K.MEMMA-9863091442",
        "anm_cho": "T HELENA(CHO)-7005429166",
        "fc_teams": "Bidya  Urmila"
    },
    {
        "sl_no": 12,
        "district": "BISHNUPUR",
        "health_center": "PHSC THINUNGEI",
        "asha": "KSH.SARAJA-9856604574",
        "anm_cho": "Y. SUNITI DEVI(CHO)-9862311378",
        "fc_teams": "Urmila"
    },
    {
        "sl_no": 13,
        "district": "BISHNUPUR",
        "health_center": "PHSC TOUBUL",
        "asha": "S.INDIRA DEVI-8798302368",
        "anm_cho": "ARUNA",
        "fc_teams": "Anita"
    },
    {
        "sl_no": 14,
        "district": "BISHNUPUR",
        "health_center": "PHSC UTLOU",
        "asha": "L.KABITA-9862250553",
        "anm_cho": "YUMNAM INDIRA DEVI(CHO)-7005098144",
        "fc_teams": "Joymala keisham"
    },
    {
        "sl_no": 15,
        "district": "BISHNUPUR",
        "health_center": "CHC NAMBOL",
        "asha": "Usharani-",
        "anm_cho": "Romila(ANM)-9615189693",
        "fc_teams": "Kiranbala  Marina  Usharani"
    },
    {
        "sl_no": 16,
        "district": "BISHNUPUR",
        "health_center": "PHC KUMBI",
        "asha": "M.Ranjana",
        "anm_cho": "Dr.Irabot",
        "fc_teams": "Promila  Lamleima"
    },
    {
        "sl_no": 17,
        "district": "BISHNUPUR",
        "health_center": "PHC KWAKTA",
        "asha": "Nasira, Akup-",
        "anm_cho": "Dr. Ziaulhaque-",
        "fc_teams": "Roshani Hemam, Reena Chanambam, Rajina"
    },
    {
        "sl_no": 18,
        "district": "BISHNUPUR",
        "health_center": "PHC LEIMAPOKPAM",
        "asha": "Leiren",
        "anm_cho": "Umakanta (MO)-8837361398",
        "fc_teams": "CH.Alexander  Kh.Puja"
    },
    {
        "sl_no": 19,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Kangla Siphai",
        "asha": "WAHENGBAM PRIYOLATA - 7629842513",
        "anm_cho": "ANM-Y.CHANDRALEKHA/9856176927",
        "fc_teams": "HUIDROM TAMPHASANA/"
    },
    {
        "sl_no": 20,
        "district": "BISHNUPUR",
        "health_center": "PHSC KEIBUL",
        "asha": "I.JAYALAXMI-6009111413",
        "anm_cho": "CHO-Sangita/9862867919",
        "fc_teams": "O.Kunjalata  H.Jayentibala"
    },
    {
        "sl_no": 21,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Nongren",
        "asha": "JUGESHWORI - 8787854867",
        "anm_cho": "CHO-BENUBALA-9856834693",
        "fc_teams": "YUMNAM MINALATA"
    },
    {
        "sl_no": 22,
        "district": "IMPHAL EAST",
        "health_center": "PHSC PUKHRAMBAM",
        "asha": "KAJEIBUNLAI - 7005984136",
        "anm_cho": "CHO-A.BIDYASHORI",
        "fc_teams": "Bisolata"
    },
    {
        "sl_no": 23,
        "district": "IMPHAL EAST",
        "health_center": "CHC SAGOLMANG",
        "asha": "N. NANDINI - 7627931447",
        "anm_cho": "AF - ELANGBAM ASHARANI 7005544535 , ANM - MANGSIDAM SUNITA 9862916510",
        "fc_teams": "OINAM BIMOLATA  WANGJAM USHARANI"
    },
    {
        "sl_no": 24,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Achanbigei",
        "asha": "A.RANIBALA - 9233577725",
        "anm_cho": "ANM-ROMILA/9612017306",
        "fc_teams": "OKRAM DASUDA/"
    },
    {
        "sl_no": 25,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Angtha",
        "asha": "T.NOMITA - 9863651511",
        "anm_cho": "SAMUKCHAM RONIBALA/7005112448",
        "fc_teams": "SALAM PROMILA"
    },
    {
        "sl_no": 26,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Chanam Sandrok",
        "asha": "I. LOIDANG - 9362651195",
        "anm_cho": "CHO - WAIKHOM SUBHASINI 8974236069",
        "fc_teams": "IRENGBAM SANATOMBI"
    },
    {
        "sl_no": 27,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Chingkhu Sambei",
        "asha": "W. IRALEIMA DEVI - 8575804261",
        "anm_cho": "CH0 - NINGOMBAM KABITA 9862070754",
        "fc_teams": "LUKRAM PROMILA DEVI"
    },
    {
        "sl_no": 28,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Huikap",
        "asha": "Leila Khulakpam - 85755150689",
        "anm_cho": "Cho Ranjana/8787865576",
        "fc_teams": "Promila"
    },
    {
        "sl_no": 29,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Irilbung",
        "asha": "TH. INAO - 9862804200",
        "anm_cho": "CHO - KHUNDRAKPAM REENA DEVI 7005565692",
        "fc_teams": "LEISHANGTHEM SULOCHANA"
    },
    {
        "sl_no": 30,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Kairang Muslim",
        "asha": "AMITA-9856861301",
        "anm_cho": "CHO-THANGJAM NALINI/9402614029",
        "fc_teams": "JESHLIN/JELYNA LAISHRAM  JELYNA LAISHRAM"
    },
    {
        "sl_no": 31,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Keibi",
        "asha": "I.JAYALAXMI-6009111413",
        "anm_cho": "CHO-Sangita/9862867919",
        "fc_teams": "Rojita Mangsatabam  YUMNAM MINALATA"
    },
    {
        "sl_no": 32,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Keikol",
        "asha": "NG.INDRANI - 8414921389",
        "anm_cho": "ANM-MOIRANGTHEM PREMJALI/9863801793",
        "fc_teams": "NAYENNI CHANU/"
    },
    {
        "sl_no": 33,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Keirao Wangkhem",
        "asha": "I. PUNI - 9366577344",
        "anm_cho": "CHO - ATHOKPAM UMABATI 9862253120",
        "fc_teams": "CHINGAKHAM INDIRA LEIMA"
    },
    {
        "sl_no": 34,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Khabeisoi",
        "asha": "BITA SHAHANI - 9612824706",
        "anm_cho": "CHO - CHABUNGBAM BINDYA , 6909504259",
        "fc_teams": "KANGABAM JAYAKUMARI"
    },
    {
        "sl_no": 35,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Khurai Heikrumakhong",
        "asha": "IROM BANDIKA - 9366075409",
        "anm_cho": "CHO - KONJENGBAM ROMI 9366331711",
        "fc_teams": "HUIDROM NIRMALA"
    },
    {
        "sl_no": 36,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Khurai Heinoumakhong",
        "asha": "RANJANA - 9366415124",
        "anm_cho": "CHO - RK DEVALA 9862071469",
        "fc_teams": "THONGAM INDIRA"
    },
    {
        "sl_no": 37,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Khurai Laiwangma",
        "asha": "SHANTIBAL - 8132085334",
        "anm_cho": "CHO - MUTUM SANATOMBI CHANU 8131879107",
        "fc_teams": "LEIMAPOKPAM BIJAYA CHANU"
    },
    {
        "sl_no": 38,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Khurai Sajor Leikai",
        "asha": "AHANTHEM NETASHOWRI  - 8837225752",
        "anm_cho": "CHO - LAISHRAM SHAMILATA 8837027959",
        "fc_teams": "LOUSHAMBAM REBIKA CHANU"
    },
    {
        "sl_no": 39,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Kiyamgei Khagi",
        "asha": "Y. KUNJESWARI DEVI - 8974821940",
        "anm_cho": "CHO - WAIKHOM BIDYALUXMI 8731043774",
        "fc_teams": "THIYAM BISHOYA  OINAM OJIT SINGH"
    },
    {
        "sl_no": 40,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Kiyamgei Muslim",
        "asha": "SUSHILLA - 8837299022",
        "anm_cho": "ANM BIMOLA/8732065583",
        "fc_teams": "OINAM OJIT SINGH"
    },
    {
        "sl_no": 41,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Kongba",
        "asha": "Manao - 9615611304",
        "anm_cho": "Ashem.Jaya/8974713873",
        "fc_teams": "NINGthOUJAM ARUNA"
    },
    {
        "sl_no": 42,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Laipham Khunou",
        "asha": "HOIKHOINEI - 9862413447",
        "anm_cho": "CHO-NG.AJEETA/7005289766",
        "fc_teams": "YUMNAM SONIA/"
    },
    {
        "sl_no": 43,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Ningomthong Kitnapanung",
        "asha": "MINAKSHI - 8798967901",
        "anm_cho": "THONGAM NIRMALA/9402254772",
        "fc_teams": "Khoisnam Ranjita"
    },
    {
        "sl_no": 44,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Ningomthongjao",
        "asha": "H.ROMA - 9383352471",
        "anm_cho": "CHO-SARMILA THOKCHOM/8131800136",
        "fc_teams": "ATHOKPAM ROJITA"
    },
    {
        "sl_no": 45,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Oksu",
        "asha": "KAJEIBUNLAI - 7005984136",
        "anm_cho": "CHO-A.BIDYASHORI",
        "fc_teams": "JELYNA LAISHRAM"
    },
    {
        "sl_no": 46,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Sanjenbam",
        "asha": "W.BINASHAKHI - 9863824318",
        "anm_cho": "ANM- KH MERINDA-9856701354",
        "fc_teams": "LAISHRAM INDIRA/"
    },
    {
        "sl_no": 47,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Seijang",
        "asha": "L.PREMILA DEVI-9366484133",
        "anm_cho": "CHO-SHILLA-9856128418",
        "fc_teams": "SONIA HANGLEM/"
    },
    {
        "sl_no": 48,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Sekta",
        "asha": "L.SHANTIBALA - 9862516566",
        "anm_cho": "CHO-MERINA-8259969713",
        "fc_teams": "SONIA HANGLEM/"
    },
    {
        "sl_no": 49,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Takhel",
        "asha": "KHONGBANTABAM GANITA - 9862848297",
        "anm_cho": "ANM-INDIRA/6009127506",
        "fc_teams": "JELYNA LAISHRAM/"
    },
    {
        "sl_no": 50,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Tellou Chana",
        "asha": "KHONGBANTABAM YAISANA - 7085914873",
        "anm_cho": "CHO-IROM ANESHWORI-9615473270",
        "fc_teams": "MANGSATABAM ROJITA"
    },
    {
        "sl_no": 51,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Thambalkhong",
        "asha": "Sarmila - 9863713475",
        "anm_cho": "cho Leihao/7005335172",
        "fc_teams": "MAMTAJ SAHANI"
    },
    {
        "sl_no": 52,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Top Chingtha",
        "asha": "SHEETAL - 7005385727",
        "anm_cho": "CHO-KH BEDA/9383351696",
        "fc_teams": "SHEETAL SHARMEE"
    },
    {
        "sl_no": 53,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Uchekon",
        "asha": "N.KAMALA - 9774584659",
        "anm_cho": "Cho -Rebika/8258969894",
        "fc_teams": "AGUSANA"
    },
    {
        "sl_no": 54,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Uchekon Laikon",
        "asha": "TH.BINASHAKHI - 9856592929",
        "anm_cho": "CHO-T.BABITA/9856407027",
        "fc_teams": "ATHOKPAM ROJITA"
    },
    {
        "sl_no": 55,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Waiton",
        "asha": "TH. YAIPHABI - 7085856156",
        "anm_cho": "CHO - W. RITA 7085513394",
        "fc_teams": "HUIDROM NIRMALA"
    },
    {
        "sl_no": 56,
        "district": "IMPHAL EAST",
        "health_center": "PHC AKAMPAT",
        "asha": "L.Inaobi - 7640959572",
        "anm_cho": "P.Lodia-9612456792",
        "fc_teams": "LAISHRAM MENEKA,  Saikhom Sonia"
    },
    {
        "sl_no": 57,
        "district": "IMPHAL EAST",
        "health_center": "PHC ANDRO",
        "asha": "Chingakham Lalita - 8730834451",
        "anm_cho": "Asheibam.Premabati",
        "fc_teams": "ABHARANI  YUREMBAM JOGITA"
    },
    {
        "sl_no": 58,
        "district": "IMPHAL EAST",
        "health_center": "PHC BASHIKHONG",
        "asha": "S.Sakhi - 6901674620",
        "anm_cho": "Pinky/8794160670",
        "fc_teams": "KHOISNAM RANJITA"
    },
    {
        "sl_no": 59,
        "district": "IMPHAL EAST",
        "health_center": "PHC HEINGANG",
        "asha": "SAPAM PREMILA(P-1)/WAIKHOM SAKHITOMBI(P-2) - 9862196476(P-1)/9612290510(P-2)",
        "anm_cho": "ANM-SOMI/9856600778",
        "fc_teams": "AYEKPAM BIBIKA/"
    },
    {
        "sl_no": 60,
        "district": "IMPHAL EAST",
        "health_center": "PHC KEIRAO MAKTING",
        "asha": "Joymala - 6909962753",
        "anm_cho": "Loichombam .Kumari/7005547930",
        "fc_teams": "ARAMBAM LINthOI"
    },
    {
        "sl_no": 61,
        "district": "IMPHAL EAST",
        "health_center": "PHC LAMLAI",
        "asha": "E.BIJAYA - 8794309949",
        "anm_cho": "ANM-PUKHRAMBAM SUNIBALA/9612996880",
        "fc_teams": "S SANDHYARANI/"
    },
    {
        "sl_no": 62,
        "district": "IMPHAL EAST",
        "health_center": "PHC Nongpok Keithelmanbi",
        "asha": "E.BIJAYA - 8794309949",
        "anm_cho": "ANM-PUKHRAMBAM SUNIBALA/9612996880",
        "fc_teams": "LEISHANA  SILVIA"
    },
    {
        "sl_no": 63,
        "district": "IMPHAL EAST",
        "health_center": "PHC SAWOMBUNG",
        "asha": "RANJANA - 7085640381",
        "anm_cho": "ANM-JAMUNA/7005160219",
        "fc_teams": "YUMNAM MINALATA  MANGSATABAM ROJITA/"
    },
    {
        "sl_no": 64,
        "district": "IMPHAL EAST",
        "health_center": "PHC YAINGANGPOKPI",
        "asha": "CHIROM IBEMCHOUBI - 8837326014",
        "anm_cho": "ANM-Y.MEMTHOI-9856211327/RADHARANI-7005124606",
        "fc_teams": "IBEMCHA CHONGTHAM/NGANGOM JOSHIMALA  NGANGOM JOSHIMALA"
    },
    {
        "sl_no": 65,
        "district": "IMPHAL EAST",
        "health_center": "PHC YAMBEM",
        "asha": "Annarkali - 7005962764",
        "anm_cho": "K.joshila/8867365317",
        "fc_teams": "MAKAKMAYUM TAJIMA  PREETY"
    },
    {
        "sl_no": 66,
        "district": "IMPHAL EAST",
        "health_center": "UPHC KSHETRIGAO",
        "asha": "PEMA BIBI - 8731956691",
        "anm_cho": "ANM - IROM RANJITA 7005092521",
        "fc_teams": "KEINOU MEENA AZMI  RAZIYA SULTANA"
    },
    {
        "sl_no": 67,
        "district": "IMPHAL EAST",
        "health_center": "UPHC MANTRIPUKHRI",
        "asha": "GANGA  - 8119815711",
        "anm_cho": "ANM - SANGITA 8787447575",
        "fc_teams": "NURSHAD"
    },
    {
        "sl_no": 68,
        "district": "IMPHAL EAST",
        "health_center": "UPHC MINUTHONG",
        "asha": "KAMEI ABOLLU  - 9862281400",
        "anm_cho": "ANM - URMILA 9077535363",
        "fc_teams": "HAORONGBAM DICKINSON  LOUSHAMBAM REBIKA"
    },
    {
        "sl_no": 69,
        "district": "IMPHAL EAST",
        "health_center": "UPHC Sangaipat",
        "asha": "LAISHRAM MEMECHA - 9089345616",
        "anm_cho": "ANM - THOKCOM ROMA 9366795047",
        "fc_teams": "KEISHAM JOYSON"
    },
    {
        "sl_no": 70,
        "district": "IMPHAL WEST",
        "health_center": "PHSC AWANG JIRI",
        "asha": "KH BIMOLATA-8732886575",
        "anm_cho": "CHO Geetarani -9612698787",
        "fc_teams": "ARAMBAM CHITRABALA"
    },
    {
        "sl_no": 71,
        "district": "IMPHAL WEST",
        "health_center": "PHSC AWANG KHUNOU",
        "asha": "LATA-9774868389",
        "anm_cho": "CHO RK.Lelina-8837423904",
        "fc_teams": "KONSAM CHANDANI DEVI"
    },
    {
        "sl_no": 72,
        "district": "IMPHAL WEST",
        "health_center": "PHSC BAMDIAR",
        "asha": "M ROBITA-9856433213",
        "anm_cho": "CHO RK.Bindiya-9856120177/7005867398",
        "fc_teams": "YENGKHOM MENAKA"
    },
    {
        "sl_no": 73,
        "district": "IMPHAL WEST",
        "health_center": "PHSC HEIGRUJAM",
        "asha": "BINASHAKI-9612557273",
        "anm_cho": "CHO L.Sushila-8131070478",
        "fc_teams": "ATOM KIRAN SINGH"
    },
    {
        "sl_no": 74,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KANGMONG",
        "asha": "SONIA-7005707302",
        "anm_cho": "CHO Ksh.Pinky-8787302352",
        "fc_teams": "KONTHOUJAM SUJATA DEVI"
    },
    {
        "sl_no": 75,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KHABI THANGTEK",
        "asha": "SEITAMALA-9366064507",
        "anm_cho": "CHO Romila Heirangkhongjam-8414889889",
        "fc_teams": "THIYAM SANDHYARANI DEVI"
    },
    {
        "sl_no": 76,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KONTHOUJAM",
        "asha": "BORKEINA-9615144600",
        "anm_cho": "CHO Sapam Romika-8787639170",
        "fc_teams": "HWAIBAM RITA DEVI"
    },
    {
        "sl_no": 77,
        "district": "IMPHAL WEST",
        "health_center": "PHSC N KEITHELMANBI",
        "asha": "L NIRMALA-6009051039",
        "anm_cho": "CHO Soubam Ninasana-7308266360",
        "fc_teams": "NONGMAITHEM JAMUNA DEVI"
    },
    {
        "sl_no": 78,
        "district": "IMPHAL WEST",
        "health_center": "PHSC SAGOLBAND LAMKHAI",
        "asha": "N SHANTI-7005492867",
        "anm_cho": "CHO Hijam Kamala-8787724595",
        "fc_teams": "RESHMA WANGKHEM"
    },
    {
        "sl_no": 79,
        "district": "IMPHAL WEST",
        "health_center": "PHSC SANGAIPROU",
        "asha": "SOLANPHY-6909672383",
        "anm_cho": "CHO Laishram Rebina-9774328665",
        "fc_teams": "PUKHRAMBRAM DHANESHORI"
    },
    {
        "sl_no": 80,
        "district": "IMPHAL WEST",
        "health_center": "PHSC TAOBUNGKHOK",
        "asha": "IBEMU-9612449900",
        "anm_cho": "ANM Pramodini-9862291645",
        "fc_teams": "SWEETY MOIRANGTHEM"
    },
    {
        "sl_no": 81,
        "district": "IMPHAL WEST",
        "health_center": "PHSC YUREMBAM",
        "asha": "L LOIDANG-8974407021",
        "anm_cho": "CHO Robita-6009280595",
        "fc_teams": "SUSHIMA KONTHOUJAM"
    },
    {
        "sl_no": 82,
        "district": "IMPHAL WEST",
        "health_center": "CHC KHUMBONG",
        "asha": "BANDANA-9366268162",
        "anm_cho": "ANM BINDIYA-923378766",
        "fc_teams": "HWAIBAM SUJETA DEVI"
    },
    {
        "sl_no": 83,
        "district": "IMPHAL WEST",
        "health_center": "CHC SEKMAI",
        "asha": "Nungleppam Chandramala Devi-9362429302",
        "anm_cho": "KHERODA-8414819645",
        "fc_teams": "MAHARAMBAM TAMANNA  LAIMAYUM SANDESHIYA"
    },
    {
        "sl_no": 84,
        "district": "IMPHAL WEST",
        "health_center": "CHC WANGOI",
        "asha": "Asem Ranjita Devi-9612225562",
        "anm_cho": "MO Sushila-",
        "fc_teams": "Oinam Tamphasana  Nameirakpam Prabindiya"
    },
    {
        "sl_no": 85,
        "district": "IMPHAL WEST",
        "health_center": "Dispensory Konjeng Leikai(Homeo)",
        "asha": "Konjengbam Anuradha-9856333617",
        "anm_cho": "ANM Tilotama-6033816133",
        "fc_teams": "HEISNAM MADHURI"
    },
    {
        "sl_no": 86,
        "district": "IMPHAL WEST",
        "health_center": "PHSC AWANG WABAGAI",
        "asha": "Khumukcham Miranda Devi-9856746085",
        "anm_cho": "DIPTI-9366132511",
        "fc_teams": "IRUNGBAM SOMOLA"
    },
    {
        "sl_no": 87,
        "district": "IMPHAL WEST",
        "health_center": "PHSC HAORANG SABAL DISPENSARY",
        "asha": "L SOBITA-9862345141",
        "anm_cho": "SHANTI-8415999735",
        "fc_teams": "ANGOM PREMILA  HEIKHAM HELENBI"
    },
    {
        "sl_no": 88,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KADANGBAND",
        "asha": "A.ELIZABETH-7085629566",
        "anm_cho": "N.BISESHWORI-9861449639",
        "fc_teams": "HEIKHAM HELENBI  ANGOM PREMILA"
    },
    {
        "sl_no": 89,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KANGLATOMBI",
        "asha": "Geeta Devi Gautam-8974186917",
        "anm_cho": "G.MARY-9612382506",
        "fc_teams": "RESHMA THAPA"
    },
    {
        "sl_no": 90,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KHAMNAM BAZAR",
        "asha": "W LOIDANG-8119879369",
        "anm_cho": "SUSHILA-8729866362",
        "fc_teams": "THOUNAOJAM MELODY  SAMURAILATPAM BINARANI"
    },
    {
        "sl_no": 91,
        "district": "IMPHAL WEST",
        "health_center": "PHSC LANGOL",
        "asha": "NO ASHA-",
        "anm_cho": "LOIDANG",
        "fc_teams": "PEMILA"
    },
    {
        "sl_no": 92,
        "district": "IMPHAL WEST",
        "health_center": "PHSC MAKLANG",
        "asha": "RATIPIYARI-985674840",
        "anm_cho": "TH.ROMITA-8794375730",
        "fc_teams": "NINGTHOUJAM ROJI"
    },
    {
        "sl_no": 93,
        "district": "IMPHAL WEST",
        "health_center": "PHSC NONGCHUP KAMENG",
        "asha": "Lourembam Brajeshwori Devi-9862546135",
        "anm_cho": "KH.ASHARANI-9856408415",
        "fc_teams": "THENGUJAM PRIYADARSHINI  KH. CHANDRALEKHA"
    },
    {
        "sl_no": 94,
        "district": "IMPHAL WEST",
        "health_center": "PHSC PHUMLOU",
        "asha": "Irengbam Sadhana Devi-9862095513",
        "anm_cho": "L.BISHESWARI-9612056724",
        "fc_teams": "HEMAN SONIA"
    },
    {
        "sl_no": 95,
        "district": "IMPHAL WEST",
        "health_center": "PHSC TAKYEL KHONGBAL",
        "asha": "INDIRA-9856674080",
        "anm_cho": "M.ASHALATA-8974902628",
        "fc_teams": "MAIBAM MILIMA"
    },
    {
        "sl_no": 96,
        "district": "IMPHAL WEST",
        "health_center": "PHSC TENDONGYAN",
        "asha": "Wangkhem Sadhana Devi-9612750726",
        "anm_cho": "TH.BIDYARANI-9862709698",
        "fc_teams": "ANGOMJAMBAM INDIRA"
    },
    {
        "sl_no": 97,
        "district": "IMPHAL WEST",
        "health_center": "UPHC IROISHENBA",
        "asha": "CH. ASHALATA-9774226008",
        "anm_cho": 0,
        "fc_teams": "KALPANA MUTUM  Phijam Gaitri  FRENCYLAR  Konthoujam Roshni Devi  LATABI  Gurumayum Kiranmala Devi"
    },
    {
        "sl_no": 98,
        "district": "IMPHAL WEST",
        "health_center": "KWAKEITHEL",
        "asha": "Konjengbam Anuradha-9856333617",
        "anm_cho": "ANM Tilotama-6033816133",
        "fc_teams": "Leishangthem Radhika  K Babita  RajKumari Sophia Devi"
    },
    {
        "sl_no": 99,
        "district": "IMPHAL WEST",
        "health_center": "LAMDENG",
        "asha": "Thoudam Sanahanbi Devi-9362648960",
        "anm_cho": "S.LEINAMANBI-7005783261",
        "fc_teams": "MAIBAM MILIMA"
    },
    {
        "sl_no": 100,
        "district": "IMPHAL WEST",
        "health_center": "LANGOL TARUNG",
        "asha": "Thoudam Sanahanbi Devi-9362648960",
        "anm_cho": "S.LEINAMANBI-7005783261",
        "fc_teams": "SALAM SANAJAOBI  mOIRANGTHEM BABITA  Maisnam Puinabati Devi  Thoudam Frencylar / Ningthoujam Latabi Devi  /  Hijam Somila Devi  SURBALA"
    },
    {
        "sl_no": 101,
        "district": "IMPHAL WEST",
        "health_center": "PHSC MAYANG LANGJING",
        "asha": "Potsangbam Ranjita Devi-9612439680",
        "anm_cho": "RK.TAMPHASANA-9862782861",
        "fc_teams": "PHAIRENBAM ASHARANI"
    },
    {
        "sl_no": 102,
        "district": "IMPHAL WEST",
        "health_center": "PHC Kakwa",
        "asha": "Ng. Bonarani-9774341163",
        "anm_cho": "Hemabati-ANM",
        "fc_teams": "Eliya Waikhom  Jenny Elangbam  Thokchom Indira Devi  Takhellambam Ritu Devi"
    },
    {
        "sl_no": 103,
        "district": "IMPHAL WEST",
        "health_center": "PHC KHONGHAMPAT",
        "asha": "W. TAMPHASANA-7085723006",
        "anm_cho": "N.PEMILA-9862847732",
        "fc_teams": "ANGOMJAMBAM INDIRA"
    },
    {
        "sl_no": 104,
        "district": "IMPHAL WEST",
        "health_center": "PHC KHURKHUL",
        "asha": "Y Sorojini Devi-9862707106",
        "anm_cho": "NEBITA-9862095790",
        "fc_teams": "TH.PRIYADARSHINI  KH. CHANDRALEKHA  THENGUJAM PRIYADARSHINI"
    },
    {
        "sl_no": 105,
        "district": "IMPHAL WEST",
        "health_center": "PHC Mekola",
        "asha": "Th. Robita-9774793694",
        "anm_cho": "CHO Okram Tanuja-9863527258",
        "fc_teams": "NGANGOM PANTHOI"
    },
    {
        "sl_no": 106,
        "district": "IMPHAL WEST",
        "health_center": "PHC PHAYENG",
        "asha": "NIRUBALA-8119954699",
        "anm_cho": "CH.UMARANI-8787790630",
        "fc_teams": "ANGOMJAMBAM INDIRA"
    },
    {
        "sl_no": 107,
        "district": "IMPHAL WEST",
        "health_center": "PHC SALAM",
        "asha": "REENA-",
        "anm_cho": "TH.SUNOLATA-9366896502",
        "fc_teams": "TONGBRAM DABAYENTI"
    },
    {
        "sl_no": 108,
        "district": "IMPHAL WEST",
        "health_center": "PHC SEKMAIJING",
        "asha": "Hemabati-7423906034",
        "anm_cho": "ANM KAMALA-8794108826",
        "fc_teams": "Hawaibam Sujeta Devi  NINGTHOUJAM OPHELIA"
    },
    {
        "sl_no": 109,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Bengoon",
        "asha": "Marida-8575452139",
        "anm_cho": "CHO Pratima-9862722308",
        "fc_teams": "Farana  Mufidah Bembem  FM ASHMA  FM Farana"
    },
    {
        "sl_no": 110,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Chirai",
        "asha": "Thokchom Sangeeta-8787535977",
        "anm_cho": "CHO Minee-7005013867",
        "fc_teams": "Heisnam Monika"
    },
    {
        "sl_no": 111,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Hiyangthang",
        "asha": "H. Sanahanbi-9856504623",
        "anm_cho": "CHO Ranjana-7308677735",
        "fc_teams": "Kilabi Buyaimayum"
    },
    {
        "sl_no": 112,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Iram Siphai",
        "asha": "L. Manimacha-7629080369",
        "anm_cho": "Damayenti CHO-8794748381",
        "fc_teams": "Yengkhom Somendro Singh"
    },
    {
        "sl_no": 113,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Irom Meijrao",
        "asha": "S. Binarani-8119951654",
        "anm_cho": "CHO L.Sushmita-7085269155",
        "fc_teams": "CHINGKHAMAYUM LILY"
    },
    {
        "sl_no": 114,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Kokchai",
        "asha": "Khaidem Bijaya-7085194459",
        "anm_cho": "CHOBidyarani-9856899011",
        "fc_teams": "Oinam Tamphasana"
    },
    {
        "sl_no": 115,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Komlakhong",
        "asha": "Ibema-9612730113",
        "anm_cho": "MHW KAYAMUDIN-9856123390",
        "fc_teams": "Sinam Naobi"
    },
    {
        "sl_no": 116,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Kwakeithel Heinou Khongnembi",
        "asha": "Thokchom Veronika-9402070557",
        "anm_cho": "CHO Nitarani Thongam -9378009064",
        "fc_teams": "RK. NONISANA"
    },
    {
        "sl_no": 117,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Langthabal Kunja",
        "asha": "Nalini-9612165431",
        "anm_cho": "CHO Kabita-7005061171",
        "fc_teams": "Chongtham Pushpa"
    },
    {
        "sl_no": 118,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Laphupat Tera",
        "asha": "Jida-6909613114",
        "anm_cho": "CHO Imila-8413007522",
        "fc_teams": "Thongam Joyshi"
    },
    {
        "sl_no": 119,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Malom Tuliyaima",
        "asha": "K. Premila-9774518292",
        "anm_cho": "CHO S.Geeta -7005110628",
        "fc_teams": "MOIRANGTHEM ROMITA DEVI"
    },
    {
        "sl_no": 120,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Mongsangei",
        "asha": "A. Khomdombi-8794583422",
        "anm_cho": "CHO Sapana-8415820749",
        "fc_teams": "Sushima konthoujam & Moirangthem Babita  Babita"
    },
    {
        "sl_no": 121,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Mutum Phibou",
        "asha": "T. Sangita Devi-9366616475",
        "anm_cho": "Rekhaja CHO-8837411243",
        "fc_teams": "Irom Bimola Devi"
    },
    {
        "sl_no": 122,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Naorem Chaprou",
        "asha": "N. Chandranganbi Devi-9612629279",
        "anm_cho": "A. KABITA",
        "fc_teams": "Prabindiya"
    },
    {
        "sl_no": 123,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Naoriya Pakhanglakpa",
        "asha": "R.k Inaotombi-6009120676",
        "anm_cho": "CHO  L.Debala-9774078809",
        "fc_teams": "CHINGTHAM PREMITA"
    },
    {
        "sl_no": 124,
        "district": "IMPHAL WEST",
        "health_center": "PHSC PHC Mayang Imphal",
        "asha": "Elangbam Purnima-9774787446",
        "anm_cho": "MO Kiranmala-9774718644",
        "fc_teams": "Asma  Anjita Huidrom"
    },
    {
        "sl_no": 125,
        "district": "IMPHAL WEST",
        "health_center": "PHSC PHC Samurou",
        "asha": "Kh. Sanduppi-9862696159",
        "anm_cho": "MO Francis-7629091190",
        "fc_teams": "Christina Longjam"
    },
    {
        "sl_no": 126,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Uchiwa",
        "asha": "Y. Kumudini-8415874917",
        "anm_cho": "CHO Rita-6009049298",
        "fc_teams": "Konjengbam Sanatombi Devi"
    },
    {
        "sl_no": 127,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Waisel Mapal",
        "asha": "T. Kiranbala Devi-8259901150",
        "anm_cho": "CHO H Prameshwori-7005033823",
        "fc_teams": "NGANGOM PANTHOI"
    },
    {
        "sl_no": 128,
        "district": "IMPHAL WEST",
        "health_center": "PHSC Yumnam Huidrom",
        "asha": "Gunjera-9615518661",
        "anm_cho": "Anita CHO-8837248524",
        "fc_teams": "Khaidem Sapana Devi"
    },
    {
        "sl_no": 129,
        "district": "IMPHAL WEST",
        "health_center": "SAGOLBAND",
        "asha": "L LOIDANG-8974407021",
        "anm_cho": "CHO Robita-6009280595",
        "fc_teams": "Konthoujam Bishwariya Chanu  puinabati  Leishangthem Radhika  Konthoujam Bishwariya Chanu & Mutum Kalpana  BISHWORIA & KALPANA  Maisnam Puinabati Devi  KALPANA MUTUM"
    },
    {
        "sl_no": 130,
        "district": "IMPHAL WEST",
        "health_center": "UPHC SINGJAMEI",
        "asha": "RANJEETA-6009766984",
        "anm_cho": "ANM MONITA-7641031973",
        "fc_teams": "Kshetrimayum Sonia  Mairenbam Sanamatum  +  Thokchom Indira Devi  Lata  LATABI  KEISHAM NIRODA  K BABITA"
    },
    {
        "sl_no": 131,
        "district": "KAKCHING",
        "health_center": "PHSC IRENGBAND",
        "asha": "K.Manitombi Devi",
        "anm_cho": "Cho-Bembem-9654438201",
        "fc_teams": "Ashalata, Nganthoi"
    },
    {
        "sl_no": 132,
        "district": "KAKCHING",
        "health_center": "PHSC WANGOO AHALLUP",
        "asha": "BIBISHORI",
        "anm_cho": "INDIRA",
        "fc_teams": "L.Ronibala"
    },
    {
        "sl_no": 133,
        "district": "KAKCHING",
        "health_center": "PHSC KEIRAK",
        "asha": "UMA",
        "anm_cho": "Cho-sarda-7005125022",
        "fc_teams": "nganthoi  Pushpa"
    },
    {
        "sl_no": 134,
        "district": "KAKCHING",
        "health_center": "PHSC LANGMEIDONG",
        "asha": "PRAMO",
        "anm_cho": "cho-loidang-7628961711",
        "fc_teams": "Suhetra"
    },
    {
        "sl_no": 135,
        "district": "KAKCHING",
        "health_center": "PHSC NUNGOO CHAIREN",
        "asha": "NUNGSHI",
        "anm_cho": "Cho- Ebeshana-8119926695",
        "fc_teams": "shilpa"
    },
    {
        "sl_no": 136,
        "district": "KAKCHING",
        "health_center": "PANGALTABI",
        "asha": "Shusila-8575171104",
        "anm_cho": "Cho-jeni-8787828519",
        "fc_teams": "shilpa"
    },
    {
        "sl_no": 137,
        "district": "KAKCHING",
        "health_center": "PHC Hiyanglam",
        "asha": "SANDHYARANI",
        "anm_cho": "MEMI",
        "fc_teams": "Joyshi"
    },
    {
        "sl_no": 138,
        "district": "KAKCHING",
        "health_center": "PHC WANGOO",
        "asha": "Binota",
        "anm_cho": "Premita",
        "fc_teams": "Sophia"
    },
    {
        "sl_no": 139,
        "district": "KAKCHING",
        "health_center": "PHC Pallel",
        "asha": "THOIBIMACHA",
        "anm_cho": "Anm-Iarabanta-7085830218",
        "fc_teams": "Anupama"
    },
    {
        "sl_no": 140,
        "district": "KAKCHING",
        "health_center": "SC SORA",
        "asha": "THOIBI",
        "anm_cho": "Cho- Rohima-7085566450",
        "fc_teams": "Anupama"
    },
    {
        "sl_no": 141,
        "district": "KAKCHING",
        "health_center": "UPHC KAKCHING",
        "asha": "pramodini-6009267003",
        "anm_cho": "Anm-somolini-9863226310",
        "fc_teams": "Rani  Pushpa"
    },
    {
        "sl_no": 142,
        "district": "KAKCHING",
        "health_center": "PHSC WABAGAI",
        "asha": "L BIMOLA",
        "anm_cho": "Cho- Shandhyarani-9615001816",
        "fc_teams": "Pushpa  Ronibala"
    },
    {
        "sl_no": 143,
        "district": "KAKCHING",
        "health_center": "PHSC WAIKHONG",
        "asha": "THAMBAL",
        "anm_cho": "Cho- Bembem-9615586180",
        "fc_teams": "suhtra"
    },
    {
        "sl_no": 144,
        "district": "SENAPATI",
        "health_center": "DISTRICT HOSPITAL Senapati",
        "asha": "Hovala",
        "anm_cho": "Losa",
        "fc_teams": "M Rodah"
    },
    {
        "sl_no": 145,
        "district": "THOUBAL",
        "health_center": "PHSC ATHOKPAM",
        "asha": "A.Sangai Devi_9862273294",
        "anm_cho": "Deddy-CHO - 9774947085",
        "fc_teams": "BRAINIKA"
    },
    {
        "sl_no": 146,
        "district": "THOUBAL",
        "health_center": "PHSC Chandrakhong",
        "asha": "W.MEMJAOBI _ 8730892108",
        "anm_cho": "Sandhya-CHO - 8787743917",
        "fc_teams": "RITA  SANATOMBI"
    },
    {
        "sl_no": 147,
        "district": "THOUBAL",
        "health_center": "PHSC Chaobok Kabui",
        "asha": "WAKILA",
        "anm_cho": "Okram.Victoria - 7005144536",
        "fc_teams": "TH SEEMA"
    },
    {
        "sl_no": 148,
        "district": "THOUBAL",
        "health_center": "PHSC CHC Heirok",
        "asha": "NINGTHOUJAM SUBASHINI DEVI _ 9089299258",
        "anm_cho": "AF-Usharani - 6009565042",
        "fc_teams": "PRABITA  NIRUPAMA  CHINGKHEINGANBI  SONICA  PRIYA_"
    },
    {
        "sl_no": 149,
        "district": "THOUBAL",
        "health_center": "PHSC HAOKHA",
        "asha": "N. Leimaton Devi _ 9856138913",
        "anm_cho": "RONIKA - 6009881647",
        "fc_teams": "Y MUKTI"
    },
    {
        "sl_no": 150,
        "district": "THOUBAL",
        "health_center": "PHSC Haoreibi Mayai Leikai",
        "asha": "FARIDA _ 9366950784",
        "anm_cho": "Ranjeeta-CHO - 70052064245,",
        "fc_teams": "DP ARISHMA  NEELAM SAHANI"
    },
    {
        "sl_no": 151,
        "district": "THOUBAL",
        "health_center": "PHSC Haoreibi Turel Ahanbi",
        "asha": "FATIMA BEGUM _ 9615011144",
        "anm_cho": "Anita-CHO - 8787643850",
        "fc_teams": "H. ANITA"
    },
    {
        "sl_no": 152,
        "district": "THOUBAL",
        "health_center": "PHSC Heibong Makhong",
        "asha": "Sahida _ 8731936752",
        "anm_cho": "Bijayalata-CHO - 9089548059",
        "fc_teams": "SHANTABIR"
    },
    {
        "sl_no": 153,
        "district": "THOUBAL",
        "health_center": "PHSC Irong Chesaba",
        "asha": "Ym.Ibemcha _ 9862417633",
        "anm_cho": "Rukshana-CHO - 9862219151",
        "fc_teams": "FARHEEN NEHA"
    },
    {
        "sl_no": 154,
        "district": "THOUBAL",
        "health_center": "PHSC Irong Khunou",
        "asha": "Shahini _ 9383231808",
        "anm_cho": "Ruhida begum-CHO - 8014623896",
        "fc_teams": "FARHEEN NEHA"
    },
    {
        "sl_no": 155,
        "district": "THOUBAL",
        "health_center": "PHSC Irong THokchom",
        "asha": "KIRANJITA",
        "anm_cho": "USHARANI CHO-9366513730",
        "fc_teams": "SANATOMBI"
    },
    {
        "sl_no": 156,
        "district": "THOUBAL",
        "health_center": "PHSC Khangabok",
        "asha": "Mrs. Mariyum _ 6009228798",
        "anm_cho": "Sanahanbi-CHO - 9366420730",
        "fc_teams": "SHIVANI  PC MANGALLEIMA"
    },
    {
        "sl_no": 157,
        "district": "THOUBAL",
        "health_center": "PHSC Khekman",
        "asha": "SERABHANU",
        "anm_cho": "Manglembi-CHO - 8837449862",
        "fc_teams": "BEMBEM  SUMITA"
    },
    {
        "sl_no": 158,
        "district": "THOUBAL",
        "health_center": "PHSC Khoirom Kekru",
        "asha": "T.MEMTONBI DEVI _ 8178290253",
        "anm_cho": "Rashima-CHO - 8837370414",
        "fc_teams": "RITA"
    },
    {
        "sl_no": 159,
        "district": "THOUBAL",
        "health_center": "PHSC KIYAM LITANPOK",
        "asha": "Shahena Shahani _ 6009631706",
        "anm_cho": "Khambita - 9862214266",
        "fc_teams": "MONICA"
    },
    {
        "sl_no": 160,
        "district": "THOUBAL",
        "health_center": "PHSC KSHETRILEIKAI",
        "asha": "N(o) Memcha Devi _ 9856150885",
        "anm_cho": "Nomita-CHO - 9615077554",
        "fc_teams": "BIDYALUXMI  BENU  th indira"
    },
    {
        "sl_no": 161,
        "district": "THOUBAL",
        "health_center": "PHSC Langathel",
        "asha": "PUYAM BABYRANI DEVI _ 6009954943",
        "anm_cho": "Roshalin - 7005783565",
        "fc_teams": "ANUPAMA"
    },
    {
        "sl_no": 162,
        "district": "THOUBAL",
        "health_center": "PHSC LeirongTHel Malom",
        "asha": "TH.AMBRAPATI _ 9856549547",
        "anm_cho": "Ratana - 8118938161",
        "fc_teams": "PREMCHANDRA"
    },
    {
        "sl_no": 163,
        "district": "THOUBAL",
        "health_center": "PHSC Litanmakhong",
        "asha": "Ch. Rabiya _ 6033826928",
        "anm_cho": "Ak.Ronibala-CHO - 8118941187",
        "fc_teams": "ROMINA"
    },
    {
        "sl_no": 164,
        "district": "THOUBAL",
        "health_center": "PHSC Moijing",
        "asha": "SHIMLA",
        "anm_cho": "SUNOLOTA / NAJIMA",
        "fc_teams": "NGANGBI"
    },
    {
        "sl_no": 165,
        "district": "THOUBAL",
        "health_center": "PHSC NINGOMBAM",
        "asha": "Okram Sana Devi _ 8974494689",
        "anm_cho": "Monteshori - 9366145011",
        "fc_teams": "BENU  BIDYALUXMI  LEIMAHAL"
    },
    {
        "sl_no": 166,
        "district": "THOUBAL",
        "health_center": "PHSC Nungei",
        "asha": "Gulerjan _ 9378118237",
        "anm_cho": "Th. Kiranbala-CHO - 8974432242",
        "fc_teams": "TH SEEMA"
    },
    {
        "sl_no": 167,
        "district": "THOUBAL",
        "health_center": "PHSC Oinam Sawombung",
        "asha": "BM SERABANU _ 8787329706",
        "anm_cho": "Surmala-CHO - 7085164531",
        "fc_teams": "SURJIT"
    },
    {
        "sl_no": 168,
        "district": "THOUBAL",
        "health_center": "PHSC Phundrei",
        "asha": "RAZIA _ 7005676809",
        "anm_cho": "Mujyapati - 9366497387",
        "fc_teams": "SHILLA BEGUM"
    },
    {
        "sl_no": 169,
        "district": "THOUBAL",
        "health_center": "PHSC Salungpham",
        "asha": "L. Subidra Devi _ 9366607956",
        "anm_cho": "Helena-CHO - 9615212558",
        "fc_teams": "TH MINARANI"
    },
    {
        "sl_no": 170,
        "district": "THOUBAL",
        "health_center": "PHSC TenTHa",
        "asha": "Maibam Premila Devi _ 9862761476",
        "anm_cho": "Bishwapati-CHO - 9774987419",
        "fc_teams": "MENEKA  SHETAL DEVI  CHALAMBA"
    },
    {
        "sl_no": 171,
        "district": "THOUBAL",
        "health_center": "PHSC THokchom Bengi",
        "asha": "Kh. Premita _ 9366108635",
        "anm_cho": "Romita-CHO - 8787667087",
        "fc_teams": "LUXMI NEPRAM"
    },
    {
        "sl_no": 172,
        "district": "THOUBAL",
        "health_center": "PHSC THOUBAL KHUNOU",
        "asha": "L.Babita Devi _ 8794215643",
        "anm_cho": "Rebika -CHO - 8974991907",
        "fc_teams": "SANJINA  ANURADHA"
    },
    {
        "sl_no": 173,
        "district": "THOUBAL",
        "health_center": "PHSC Ukhongsang",
        "asha": "LeishangTHem Dhaneshwori Devi _ 8974096030",
        "anm_cho": "Romabati-CHO - 9862037131",
        "fc_teams": "PUINYA  SURBALA  RITA"
    },
    {
        "sl_no": 174,
        "district": "THOUBAL",
        "health_center": "PHSC WaiTHou",
        "asha": "Maimom Bdyarani Chanu _ 8014833867",
        "anm_cho": "Bidyarani - 7005440143",
        "fc_teams": "BEMBEM"
    },
    {
        "sl_no": 175,
        "district": "THOUBAL",
        "health_center": "PHSC Wangkhem",
        "asha": "LAISHRAM (O) SANATOMBI DEVI _ 9612125241",
        "anm_cho": "Kunjeshwari (CHO) - 9089380818",
        "fc_teams": "SM MAMUDA"
    },
    {
        "sl_no": 176,
        "district": "THOUBAL",
        "health_center": "CHC Haoreibi",
        "asha": "Hasim Banu _ 8974398400",
        "anm_cho": "Wakila - 8837352724",
        "fc_teams": "DP ARISHMA"
    },
    {
        "sl_no": 177,
        "district": "THOUBAL",
        "health_center": "CHC Yairipok (n)",
        "asha": "KONTHOUJAM VICTORIA DEVI _ 9862109486",
        "anm_cho": "Ch.Shusila - 8732853659",
        "fc_teams": "TANUJA"
    },
    {
        "sl_no": 178,
        "district": "THOUBAL",
        "health_center": "PHC Charangpat",
        "asha": "K. Tombi _ 8731859078",
        "anm_cho": "Prabharani - 8787676538",
        "fc_teams": "INDIRA GOLMEI"
    },
    {
        "sl_no": 179,
        "district": "THOUBAL",
        "health_center": "PHC Khoirom",
        "asha": "MRS RAHINA _ 8575611254",
        "anm_cho": "S.Romita - 9863668241",
        "fc_teams": "BIDYARANI  ANURADHA"
    },
    {
        "sl_no": 180,
        "district": "THOUBAL",
        "health_center": "PHC Khongjom",
        "asha": "SAPAM PRABHA DEVI _ 9378108214",
        "anm_cho": "Thabaton - 9615125598",
        "fc_teams": "SHILLA NAOREM  MENEKA  LEMBA"
    },
    {
        "sl_no": 181,
        "district": "THOUBAL",
        "health_center": "PHC Leisangthem",
        "asha": "TH. Gourikumari _ 9615479978",
        "anm_cho": "L.Bembem - 6909551130",
        "fc_teams": "SH ANITA"
    },
    {
        "sl_no": 182,
        "district": "THOUBAL",
        "health_center": "PHC Lilong",
        "asha": "NASIMA BANU",
        "anm_cho": "Anita - 9862013717",
        "fc_teams": "TH IBEMHAL  H ANITA  Simran nesha"
    },
    {
        "sl_no": 183,
        "district": "THOUBAL",
        "health_center": "PHC Nongpok Sekmai",
        "asha": "THangjam Bidiyapati Devi _ 7629082929",
        "anm_cho": "Ng.Shanti - 7084598135",
        "fc_teams": "PUINYA  SURBALA"
    },
    {
        "sl_no": 184,
        "district": "THOUBAL",
        "health_center": "PHC Sangaiyumpham",
        "asha": "Amina Bibi _ 9862923293",
        "anm_cho": "Sundari - 8014060599",
        "fc_teams": "MUMTAZ  WAJEDA"
    },
    {
        "sl_no": 185,
        "district": "THOUBAL",
        "health_center": "PHC Wangjing",
        "asha": "Brahmacharimayum Bijeyeni Devi _ 8837254009",
        "anm_cho": "Babita - 9612118694",
        "fc_teams": "SARJU  KEINAKUMARI  KALPANA"
    },
    {
        "sl_no": 186,
        "district": "THOUBAL",
        "health_center": "PHSC Ningombam",
        "asha": "Okram Sana Devi _ 8974494689",
        "anm_cho": "Monteshori - 9366145011",
        "fc_teams": "LEISANGTHEM ROMITA"
    },
    {
        "sl_no": 187,
        "district": "THOUBAL",
        "health_center": "U-PHSC Phoudel KEIRAMBI",
        "asha": "S.Romita Devi _ 9862066903",
        "anm_cho": "RAJIV",
        "fc_teams": "FATIMA"
    },
    {
        "sl_no": 188,
        "district": "THOUBAL",
        "health_center": "U-PHSC TOMJIN MAKHONG",
        "asha": "SANATOMBA",
        "anm_cho": "SANATOMBA",
        "fc_teams": "BIDYALUXMI  BENU  th indira"
    },
    {
        "sl_no": 189,
        "district": "THOUBAL",
        "health_center": "UPHC Phoudel",
        "asha": "Mrs.Serabanu _ 9615578876",
        "anm_cho": "ANM-Gunileima - 9615248065",
        "fc_teams": "FATIMA"
    },
    {
        "sl_no": 190,
        "district": "THOUBAL",
        "health_center": "UPHC THOUBAL BAZAR",
        "asha": "AK. THoibi Devi _ 6009277804",
        "anm_cho": "AK ARUNI -",
        "fc_teams": "BENU  LEIMAHAL  BEMBEM  th indira"
    },
    {
        "sl_no": 191,
        "district": "IMPHAL EAST",
        "health_center": "UPHSC Hatta Golapati",
        "asha": "RESHMA",
        "anm_cho": "KEISAM ROCKSON",
        "fc_teams": "HANJABAM BISHOYA  N. SOPHIYA"
    },
    {
        "sl_no": 192,
        "district": "IMPHAL EAST",
        "health_center": "UPHSC Palace Compound",
        "asha": "THAIBEMMA",
        "anm_cho": "REBITA",
        "fc_teams": "HIDANGMAYUM SANDHYARANI  ARUNA"
    },
    {
        "sl_no": 193,
        "district": "IMPHAL EAST",
        "health_center": "UPHSC Soibam Leikai",
        "asha": "RUINABATI",
        "anm_cho": "DR TARUN,K GUNABANTA",
        "fc_teams": "HUIDROM YAIPHABI  HANJABAM BISHOYA"
    },
    {
        "sl_no": 194,
        "district": "CHANDEL",
        "health_center": "CHC CHAKPIKARONG",
        "asha": "St. Jamhring",
        "anm_cho": "no health staff",
        "fc_teams": "BD  KHIVAR ANAL , LOVEHRING, ROSELY"
    },
    {
        "sl_no": 195,
        "district": "CHANDEL",
        "health_center": "DISTRICT HOSPITAL CHANDEL",
        "asha": "Sng Dena",
        "anm_cho": "Ng Veronica",
        "fc_teams": "BS NINGNINGLA, RANITA, MINIHRING"
    },
    {
        "sl_no": 196,
        "district": "CHANDEL",
        "health_center": "HWC KHUBUNG KHULLEN",
        "asha": "Kl Sanary",
        "anm_cho": "Ws Hringni (CHO) Nl Reena Anal (ANM)",
        "fc_teams": "BD  KHIVAR ANAL, HUTE OMEGA, ROSELY"
    },
    {
        "sl_no": 197,
        "district": "CHANDEL",
        "health_center": "PHC SAJIK TAMPAK",
        "asha": "Lamneiting",
        "anm_cho": "Lamkhokim",
        "fc_teams": "LYDIA NIANGDEIHKIM, TINNEICHONG"
    },
    {
        "sl_no": 198,
        "district": "JIRIBAM",
        "health_center": "CHC JIRIBAM",
        "asha": "Th Rina",
        "anm_cho": "Dr.Amir khan",
        "fc_teams": "ELANGBAM REELYSHORI DEVI, G GIANGUILIU RONGMEI"
    },
    {
        "sl_no": 199,
        "district": "JIRIBAM",
        "health_center": "PHSC GULARTHOL",
        "asha": "Binomala devi",
        "anm_cho": "Telsing  phaneilhing haokip",
        "fc_teams": "G GIANGUILIU RONGMEI, TABITHA KAMIEI,TH ANITA, ROMITA DEVI",
        "__empty_9": "MONALISA"
    },
    {
        "sl_no": 200,
        "district": "KAMJONG",
        "health_center": "HWC MAWAI",
        "asha": "gracie",
        "anm_cho": "NINGSHEN WORCHUILA",
        "fc_teams": "N SHANGREIWON"
    },
    {
        "sl_no": 201,
        "district": "KAMJONG",
        "health_center": "PHSC KAMJONG",
        "asha": "MINGYAOLA",
        "anm_cho": "DR.VARESO",
        "fc_teams": "N SHANGREIWON, JASHA "
    },
    {
        "sl_no": 202,
        "district": "KANGPOKPI",
        "health_center": "CHC KANGPOKPI",
        "asha": "Kimneichong",
        "anm_cho": "Dr Hoishi",
        "fc_teams": "NEICHULLOU MISAO"
    },
    {
        "sl_no": 203,
        "district": "KANGPOKPI",
        "health_center": "DISTRICT HOSPITAL KANGPOKPI",
        "asha": "Boilhing",
        "anm_cho": "Rosemary Haokip",
        "fc_teams": "CHONGBEM DOUNGAL, LAMBOIKIM KIPGEN, NEICHULLOU MISAO, RUTH GUITE"
    },
    {
        "sl_no": 204,
        "district": "PHERZAWL",
        "health_center": "CHC PARBUNG",
        "asha": "Lalmauid",
        "anm_cho": "Lahlinpu",
        "fc_teams": "LALBIEKZING , MUANKIM,TINNEITHEM"
    },
    {
        "sl_no": 205,
        "district": "SENAPATI",
        "health_center": "CHC TADUBI",
        "asha": "Athisa Anne",
        "anm_cho": "Chiifii a Charakho",
        "fc_teams": "ATHISA ANNE"
    },
    {
        "sl_no": 207,
        "district": "SENAPATI",
        "health_center": "HWC KARONG",
        "asha": "H ANILA",
        "anm_cho": "Wahengbam Bobina (ANM)",
        "fc_teams": "SAVEIKHO MS"
    },
    {
        "sl_no": 208,
        "district": "SENAPATI",
        "health_center": "HWC KOIDE",
        "asha": "V Saniiru",
        "anm_cho": "Lamhoikim",
        "fc_teams": "RODAH MS"
    },
    {
        "sl_no": 209,
        "district": "SENAPATI",
        "health_center": "HWC LAIROUCHING",
        "asha": "R Pangnila",
        "anm_cho": "Vishna",
        "fc_teams": "K DOIREIBA NICKY, RODAH,SAVEIKHO"
    },
    {
        "sl_no": 210,
        "district": "SENAPATI",
        "health_center": "HWC MARAM KHUNOU",
        "asha": "Khusbu Rai",
        "anm_cho": "Sharon",
        "fc_teams": "APRILROSE KOM"
    },
    {
        "sl_no": 211,
        "district": "SENAPATI",
        "health_center": "HWC RAMLONG",
        "asha": "Anna Veilounai",
        "anm_cho": "Rose",
        "fc_teams": "H PUNGDITA"
    },
    {
        "sl_no": 212,
        "district": "SENAPATI",
        "health_center": "HWC SHAJOUBA",
        "asha": "S Raine",
        "anm_cho": "H Ranjana devi",
        "fc_teams": "LOHRII ZACCHUES, ATHILI"
    },
    {
        "sl_no": 213,
        "district": "SENAPATI",
        "health_center": "HWC TOBUMAI",
        "asha": "Ch Lidziisa",
        "anm_cho": "PS Meena ANM",
        "fc_teams": "A ASHUNI"
    },
    {
        "sl_no": 214,
        "district": "SENAPATI",
        "health_center": "HWC WILLONG",
        "asha": "Rangdoula",
        "anm_cho": "Hiibanga Rose",
        "fc_teams": "RACHUNTHAILIU KAMEI"
    },
    {
        "sl_no": 215,
        "district": "SENAPATI",
        "health_center": "PHSC MARAM KHULLEN",
        "asha": "Rana",
        "anm_cho": "R kabitila",
        "fc_teams": "KANA MARGARET TH"
    },
    {
        "sl_no": 216,
        "district": "TAMENGLONG",
        "health_center": "DISTRICT HOSPITAL TAMENGLONG",
        "asha": "Gaipuilu Kamei",
        "anm_cho": "Lucy (ANM)",
        "fc_teams": "JANGKULIU AND SLOLOMI GANGMEI, KEININGRIANGLIU, LILY HONGNEIGONGLIU GANGMEI"
    },
    {
        "sl_no": 217,
        "district": "TENGNOUPAL",
        "health_center": "HWC KHULSAIBUNG",
        "asha": "S. Daring",
        "anm_cho": "Khaling Daiya maring",
        "fc_teams": "PRICILA KHALING"
    },
    {
        "sl_no": 218,
        "district": "TENGNOUPAL",
        "health_center": "HWC KHUNBI",
        "asha": "Dk. Tomuishang",
        "anm_cho": "Tedarshim Dangshawa",
        "fc_teams": "KOCHOM RONGLO"
    },
    {
        "sl_no": 219,
        "district": "TENGNOUPAL",
        "health_center": "HWC MACHI",
        "asha": "Ronglo Shelbongdar",
        "anm_cho": "NS levis maring, Hatjaneng mate, NS. kimjalam",
        "fc_teams": "PRICILA KHALING"
    },
    {
        "sl_no": 220,
        "district": "TENGNOUPAL",
        "health_center": "PHC AIMOL TAMPAK",
        "asha": "M Florance",
        "anm_cho": "CHO Sophia",
        "fc_teams": "PRICILA KHALING"
    },
    {
        "sl_no": 221,
        "district": "TENGNOUPAL",
        "health_center": "PHC RILRAM CENTRE",
        "asha": "KP.Tethang",
        "anm_cho": "K.c .Temui Maring",
        "fc_teams": "KENJOY TUNDARTHANG MARING"
    },
    {
        "sl_no": 222,
        "district": "TENGNOUPAL",
        "health_center": "PHC SAIVOM",
        "asha": "Lamboi",
        "anm_cho": "CHO Rakhi, ANM Shila, MPW Noor",
        "fc_teams": "PRICILA KHALING"
    },
    {
        "sl_no": 223,
        "district": "TENGNOUPAL",
        "health_center": "PHSC KHUNBI",
        "asha": "H Khamnu",
        "anm_cho": "Dangshawa Tedarshim",
        "fc_teams": "KOCHOM RONGLO"
    },
    {
        "sl_no": 224,
        "district": "TENGNOUPAL",
        "health_center": "PHSC SITA",
        "asha": "Mk. Darshim",
        "anm_cho": "Kshetrimayum Rina Devi",
        "fc_teams": "KENJOY TUNDARTHANG MARING"
    },
    {
        "sl_no": 225,
        "district": "BISHNUPUR",
        "health_center": "PHSC Ithing Khunjao",
        "asha": "Shama",
        "anm_cho": "Shakuntala Nongmaithem",
        "fc_teams": "Tongbram Gila Singh"
    },
    {
        "sl_no": 226,
        "district": "BISHNUPUR",
        "health_center": "PHSC KHORDAK ICHIN",
        "asha": "S LATAMANGI DEVI",
        "anm_cho": "KH LILY DEVI",
        "fc_teams": "N PRABINCHANDRA SINGH"
    },
    {
        "sl_no": 227,
        "district": "BISHNUPUR",
        "health_center": "PHC NINGTHOUKHONG",
        "asha": "NO ASHA",
        "anm_cho": "L CHAOBA",
        "fc_teams": "M DAINA"
    },
    {
        "sl_no": 228,
        "district": "BISHNUPUR",
        "health_center": "PHC OINAM",
        "asha": "O memthoibi",
        "anm_cho": "N Kunjalata",
        "fc_teams": "Thounaojam priyadarshini"
    },
    {
        "sl_no": 229,
        "district": "IMPHAL EAST",
        "health_center": "PHSC Naharup Makhapat",
        "asha": "Th Indubala Devi",
        "fc_teams": "P Sushitra"
    },
    {
        "sl_no": 230,
        "district": "KAKCHING",
        "health_center": "CHC SUGNU",
        "asha": "PREMITA",
        "anm_cho": "Premita",
        "fc_teams": "Yumlembam Venus"
    },
    {
        "sl_no": 231,
        "district": "KAKCHING",
        "health_center": "PHC KAKCHING KHUNOU",
        "asha": "TH. RANI DEVI",
        "anm_cho": "L.NUNGSHI DEVI",
        "fc_teams": "L SOPHIA CHANU"
    },
    {
        "sl_no": 232,
        "district": "KAKCHING",
        "health_center": "PHSC ARONG TERA",
        "asha": "MEMI",
        "anm_cho": "SAPANA",
        "fc_teams": "THONGAM JOYSHI"
    },
    {
        "sl_no": 233,
        "district": "KAKCHING",
        "health_center": "PHSC ELANGKHANGPOKPI",
        "asha": "L. Thingloulenbi Devi",
        "anm_cho": "L. Dhanapriyari Devi",
        "fc_teams": "Thongam Nganthoi Chanu"
    },
    {
        "sl_no": 234,
        "district": "KAKCHING",
        "health_center": "PHSC KEIRAK KANGJEIBUNG",
        "asha": "N. OMINA DEVI",
        "anm_cho": "N. MINORIKA DEVI",
        "fc_teams": "M MEENARANI DEVI"
    },
    {
        "sl_no": 235,
        "district": "KAKCHING",
        "health_center": "PHSC LANGMEIDONG",
        "asha": "PRAMO",
        "anm_cho": "LOIDANG",
        "fc_teams": "SUHETRA"
    },
    {
        "sl_no": 236,
        "district": "KAKCHING",
        "health_center": "PHSC MANTAK",
        "asha": "K MANALINI KOM",
        "anm_cho": "ANM- S NGANEIHOI",
        "fc_teams": "Yambem Ronibala"
    },
    {
        "sl_no": 237,
        "district": "KAKCHING",
        "health_center": "PHSC MAYENGLAMJAO",
        "asha": "S. Ibemcha Devi",
        "anm_cho": "Chingtham Mina Devi",
        "fc_teams": "Thongam Nganthoi Chanu"
    },
    {
        "sl_no": 238,
        "district": "KAKCHING",
        "health_center": "PHSC THONGAM",
        "asha": 0,
        "anm_cho": "S SUNITA",
        "fc_teams": "REETA "
    },
    {
        "sl_no": 239,
        "district": "KAKCHING",
        "health_center": "UPHC KAKCHING",
        "asha": "M. PRAMODINI DEVI",
        "anm_cho": "Y. SOMOLINI DEVI",
        "fc_teams": "N RANI DEVI"
    },
    {
        "sl_no": 240,
        "district": "KAMJONG",
        "health_center": "PHSC SHINGCHA",
        "asha": "ACHUI ZIMIK",
        "anm_cho": "SAPAIWON KEISHING",
        "fc_teams": "Jasha Lorngam"
    },
    {
        "sl_no": 241,
        "district": "IMPHAL WEST",
        "health_center": "PHC MAYANG IMPHAL",
        "asha": "PREMILA",
        "anm_cho": "Kiranmala",
        "fc_teams": "Huidrom Anjita"
    },
    {
        "sl_no": 242,
        "district": "IMPHAL WEST",
        "health_center": "PHC SAMUROU",
        "asha": "M. Pramodini",
        "anm_cho": "N. Sangita Devi",
        "fc_teams": "Christina Longjam"
    },
    {
        "sl_no": 243,
        "district": "IMPHAL WEST",
        "health_center": "PHSC CHANGANGEI",
        "asha": "Kamalapati",
        "anm_cho": "Medha",
        "fc_teams": "MOIRANGTHEM ROMITA CHANU"
    },
    {
        "sl_no": 244,
        "district": "IMPHAL WEST",
        "health_center": "PHSC KARAM HAOREIBI",
        "asha": "Thasana Devi",
        "anm_cho": "Ph Subashini",
        "fc_teams": "M Abharani Devi"
    },
    {
        "sl_no": 245,
        "district": "IMPHAL WEST",
        "health_center": "PHSC NINGOMBAM",
        "asha": "A. Memi Devi",
        "anm_cho": "Montesori",
        "fc_teams": "Akoijam Bidiyalakshmi Devi"
    },
    {
        "sl_no": 246,
        "district": "IMPHAL WEST",
        "health_center": "PHSC SAMUSANG",
        "asha": "L. Chitrarekha",
        "anm_cho": "T. Ningoltombi, Ranjana, Susila, Sunita",
        "fc_teams": "Oinam Tamphasana"
    }
]

export const healthFacilitiesUpdate1 = [
    {
        "district": "BISHNUPUR",
        "facility_name": "CHC NAMBOL",
        "id": 1,
        "type": "CHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC KUMBI",
        "id": 2,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC KWAKTA",
        "id": 3,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC LEIMAPOKPAM",
        "id": 4,
        "type": "PHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC NINGTHOUKHONG",
        "id": 5,
        "type": "PHC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHC OINAM",
        "id": 6,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC ITHING KHOLA",
        "id": 7,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC ITHING KHUNJAO",
        "id": 8,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC KEIBUL",
        "id": 9,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC KEINOU",
        "id": 10,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC KHA THINUNGEI",
        "id": 11,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC KHOIJUMAN",
        "id": 12,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC KHORDAK ICHIN",
        "id": 13,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC LEIMARAM",
        "id": 14,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC NACHOU",
        "id": 15,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC PHUBALA",
        "id": 16,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC PUKHRAMBAM",
        "id": 17,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC THINUNGEI",
        "id": 18,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC TOUBUL",
        "id": 19,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "BISHNUPUR",
        "facility_name": "PHSC UTLOU",
        "id": 20,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "CHC CHAKPIKARONG",
        "id": 21,
        "type": "CHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "DISTRICT HOSPITAL CHANDEL",
        "id": 22,
        "type": "DISTRICT",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "HWC KHUBUNG KHULLEN",
        "id": 23,
        "type": "HWC",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "CHANDEL",
        "facility_name": "PHC SAJIK TAMPAK",
        "id": 24,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "CHC SAGOLMANG",
        "id": 25,
        "type": "CHC",
        "yes_month": [
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC AKAMPAT",
        "id": 26,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC ANDRO",
        "id": 27,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC BASHIKHONG",
        "id": 28,
        "type": "PHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC HEINGANG",
        "id": 29,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC KEIRAO MAKTING",
        "id": 30,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC LAMLAI",
        "id": 31,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC SAWOMBUNG",
        "id": 32,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC YAINGANGPOKPI",
        "id": 33,
        "type": "PHC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC YAMBEM",
        "id": 34,
        "type": "PHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC ACHANBIGEI",
        "id": 35,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC ANGTHA",
        "id": 36,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC CHANAM SANDROK",
        "id": 37,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC CHINGKHU SAMBEI",
        "id": 38,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC HEIKRUMAKHONG",
        "id": 39,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC HUIKAP",
        "id": 40,
        "type": "PHSC",
        "yes_month": [
            "Aug-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC IRILBUNG",
        "id": 41,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Oct-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KAIRANG MUSLIM",
        "id": 42,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KANGLA SIPHAI",
        "id": 43,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KEIBI",
        "id": 44,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KEIKOL",
        "id": 45,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KEIRAO WANGKHEM",
        "id": 46,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KHABEISOI",
        "id": 47,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KHURAI HEINOUMAKHONG",
        "id": 48,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KHURAI LAIWANGMA",
        "id": 49,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KHURAI SAJOR LEIKAI",
        "id": 50,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KITNA PANUNG",
        "id": 51,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KIYAMGEI KHAGI",
        "id": 52,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KIYAMGEI MUSLIM",
        "id": 53,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC KONGBA",
        "id": 54,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC LAIPHAM KHUNOU",
        "id": 55,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC LUWANGSANGBAM",
        "id": 56,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC NINGOMTHONG KITNAPANUNG",
        "id": 57,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC NINGOMTHONGJAO",
        "id": 58,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC NONGREN",
        "id": 59,
        "type": "PHSC",
        "yes_month": [
            "Aug-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC OKSU",
        "id": 60,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC SANJENBAM",
        "id": 61,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC SEIJANG",
        "id": 62,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC SEKTA",
        "id": 63,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC TAKHEL",
        "id": 64,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC TELLOU CHANA",
        "id": 65,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC THAMBALKHONG",
        "id": 66,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC TOP CHINGTHA",
        "id": 67,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC UCHECKON",
        "id": 68,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC UCHECKON LAIKON",
        "id": 69,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC URUP MUSLIM AWANG LEIKEI",
        "id": 70,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC URUP SALANGPHAM",
        "id": 71,
        "type": "PHSC",
        "yes_month": [
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHSC WAITON",
        "id": 72,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC KSHETRIGAO",
        "id": 73,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC MANTRI PUKHRI",
        "id": 74,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC MINUTHONG",
        "id": 75,
        "type": "UPHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHC SANGAIPAT",
        "id": 76,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHSC HATTA GOLAPATI",
        "id": 77,
        "type": "UPHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHSC PALACE COMPOUND",
        "id": 78,
        "type": "UPHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "UPHSC SOIBAM LEIKAI",
        "id": 79,
        "type": "UPHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC AWANG SEKMAI",
        "id": 80,
        "type": "CHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC KHUMBONG",
        "id": 81,
        "type": "CHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "CHC WANGOI",
        "id": 82,
        "type": "CHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC KAKWA",
        "id": 83,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC KHONGHAMPAT",
        "id": 84,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC KHURKHUL",
        "id": 85,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC MAYANG IMPHAL",
        "id": 86,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC MEKOLA",
        "id": 87,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC PHAYENG",
        "id": 88,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC SALAM",
        "id": 89,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC SAMUROU",
        "id": 90,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHC SEKMAIJIN",
        "id": 91,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC AWANG JIRI",
        "id": 92,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC AWANG KHUNOU",
        "id": 93,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC AWANG WABAGAI",
        "id": 94,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC BAMDIAR",
        "id": 95,
        "type": "PHSC",
        "yes_month": [
            "Aug-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC BENGOON",
        "id": 96,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC CHANGANGEI",
        "id": 97,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC CHIRAI",
        "id": 98,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC HAORANG SABAL DISPENSORY",
        "id": 99,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC HEIGRUJAM",
        "id": 100,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC HIYANGTHANG",
        "id": 101,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC IRAM SIPHAI",
        "id": 102,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC IROM MEIJRAO",
        "id": 103,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KADANGBAND",
        "id": 104,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KANGLATONGBI",
        "id": 105,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KANGMONG",
        "id": 106,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KARAM HAOREIBI",
        "id": 107,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KHABI THANGTEK",
        "id": 108,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KHAMNAM BAZAAR",
        "id": 109,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KOKCHAI",
        "id": 110,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KOMLAKHONG",
        "id": 111,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KONJENG LEIKAI DISPENSORY",
        "id": 112,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KONTHOUJAM",
        "id": 113,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC KWAKEITHEL HEINOUKHONGMENBI",
        "id": 114,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC LAMDENG",
        "id": 115,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC LANGOL DISPENSORY",
        "id": 116,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC LANGTHABAL KUNJA",
        "id": 117,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC LAPHUPAT TERA",
        "id": 118,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC MAKLANG",
        "id": 119,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC MALOM TULIYAIMA",
        "id": 120,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC MAYANG LANGJING",
        "id": 121,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC MONGSANGEI",
        "id": 122,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC MUTUM PHIBOU",
        "id": 123,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC NAOREM CHAPROU",
        "id": 124,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC NAORIYA PAKHANGLAKPA",
        "id": 125,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC NINGOMBAM",
        "id": 126,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC NONGCHUP KAMENG",
        "id": 127,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC NONGCHUP KEITHELMANBI",
        "id": 128,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL EAST",
        "facility_name": "PHC NONGPOK KEITHELMANBI",
        "id": 129,
        "type": "PHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC PHUMLOU",
        "id": 130,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC SAGOLBAND LAMKHAI",
        "id": 131,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC SAMUSHANG",
        "id": 132,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC SANGAIPROU",
        "id": 133,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC TAKYEL KHONGBAN",
        "id": 134,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC TAOBUNGKHOK",
        "id": 135,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC TENDONGYAN",
        "id": 136,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC UCHIWA",
        "id": 137,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC WAISHEL MAPAL",
        "id": 138,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC YUMNAM HUIDROM",
        "id": 139,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "PHSC YUREMBAM",
        "id": 140,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC IROISEMBA",
        "id": 141,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC KWAKEITHEL",
        "id": 142,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC LANGOL TARUNG",
        "id": 143,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC SAGOLBAND",
        "id": 144,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC SINGJAMEI",
        "id": 145,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHC THANGAL BAZAR",
        "id": 146,
        "type": "UPHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "IMPHAL WEST",
        "facility_name": "UPHSC URIPOK",
        "id": 147,
        "type": "UPHSC",
        "yes_month": [
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ]
    },
    {
        "district": "JIRIBAM",
        "facility_name": "CHC JIRIBAM",
        "id": 148,
        "type": "CHC",
        "yes_month": [
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25"
        ]
    },
    {
        "district": "JIRIBAM",
        "facility_name": "PHSC GULARTHOL",
        "id": 149,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "CHC SUGNU",
        "id": 150,
        "type": "CHC",
        "yes_month": [
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC HIYANGLAM",
        "id": 151,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC KAKCHING KHUNOU",
        "id": 152,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC PALLEL",
        "id": 153,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC WANGOO",
        "id": 154,
        "type": "PHC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHC WANGOO LAIPHAM",
        "id": 155,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC ARONG TERA",
        "id": 156,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC ELANGKHANGPOKPI",
        "id": 157,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC IRENGBAND",
        "id": 158,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC KAKCHING",
        "id": 159,
        "type": "PHSC",
        "yes_month": [
            "Aug-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC KEIRAK",
        "id": 160,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC KEIRAK KANGJEIBUNG",
        "id": 161,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC LANGMEIDONG",
        "id": 162,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC MANTAK",
        "id": 163,
        "type": "PHSC",
        "yes_month": [
            "Aug-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC MAYENGLAMJAO",
        "id": 164,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC NUNGOO CHAIREN",
        "id": 165,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC PANGALTABI",
        "id": 166,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC THONGAM",
        "id": 167,
        "type": "PHSC",
        "yes_month": [
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC WABAGAI",
        "id": 168,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "PHSC WAIKHONG",
        "id": 169,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "SC SORA",
        "id": 170,
        "type": "SC",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAKCHING",
        "facility_name": "UPHC KAKCHING",
        "id": 171,
        "type": "UPHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "KAMJONG",
        "facility_name": "HWC MAWAI",
        "id": 172,
        "type": "HWC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAMJONG",
        "facility_name": "PHSC KAMJONG",
        "id": 173,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KAMJONG",
        "facility_name": "PHSC SHINGCHA",
        "id": 174,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "KANGPOKPI",
        "facility_name": "CHC KANGPOKPI",
        "id": 175,
        "type": "CHC",
        "yes_month": [
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ]
    },
    {
        "district": "KANGPOKPI",
        "facility_name": "DISTRICT HOSPITAL KANGPOKPI",
        "id": 176,
        "type": "DISTRICT",
        "yes_month": [
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25"
        ]
    },
    {
        "district": "Pherzawl",
        "facility_name": "CHC PARBUNG",
        "id": 177,
        "type": "CHC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "CHC TADUBI",
        "id": 178,
        "type": "CHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "DISTRICT HOSPITAL SENAPATI",
        "id": 179,
        "type": "DISTRICT",
        "yes_month": [
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC KARONG",
        "id": 180,
        "type": "HWC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC KOIDE",
        "id": 181,
        "type": "HWC",
        "yes_month": [
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC LAIROUCHING",
        "id": 182,
        "type": "HWC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC MARAM KHUNOU",
        "id": 183,
        "type": "HWC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Nov-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC RAMLONG",
        "id": 184,
        "type": "HWC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC SHAJOUBA",
        "id": 185,
        "type": "HWC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC TOBUMAI",
        "id": 186,
        "type": "HWC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "HWC WILLONG",
        "id": 187,
        "type": "HWC",
        "yes_month": [
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "SENAPATI",
        "facility_name": "PHSC MARAM KHULLEN",
        "id": 188,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "TAMENGLONG",
        "facility_name": "DISTRICT HOSPITAL TAMENGLONG",
        "id": 189,
        "type": "DISTRICT",
        "yes_month": [
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "HWC KHULSAIBUNG",
        "id": 190,
        "type": "HWC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "HWC KHUNBI",
        "id": 191,
        "type": "HWC",
        "yes_month": [
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "HWC MACHI",
        "id": 192,
        "type": "HWC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHC AIMOL TAMPAK",
        "id": 193,
        "type": "PHC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHC RILRAM CENTRE",
        "id": 194,
        "type": "PHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHC SAIVOM",
        "id": 195,
        "type": "PHC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHSC KHUNBI",
        "id": 196,
        "type": "PHSC",
        "yes_month": [
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ]
    },
    {
        "district": "TENGNOUPAL",
        "facility_name": "PHSC SITA",
        "id": 197,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "CHC HAOREIBI",
        "id": 198,
        "type": "CHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "CHC HEIROK",
        "id": 199,
        "type": "CHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "CHC YAIRIPOK",
        "id": 200,
        "type": "CHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC CHARANGPAT",
        "id": 201,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC KHOIROM",
        "id": 202,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC KHONGJOM",
        "id": 203,
        "type": "PHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC LEISHANGTHEM",
        "id": 204,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC LILONG",
        "id": 205,
        "type": "PHC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC NONGPOK SEKMAI",
        "id": 206,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC SANGAIYUMPHAM",
        "id": 207,
        "type": "PHC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHC WANGJING",
        "id": 208,
        "type": "PHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC ATHOKPAM",
        "id": 209,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC CHANDRAKHONG",
        "id": 210,
        "type": "PHSC",
        "yes_month": [],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC CHAOBOK KABUI",
        "id": 211,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC HAOKHA",
        "id": 212,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC HAOREIBI MAYAI LEIKAI",
        "id": 213,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC HAOREIBI TUREL AHANBI",
        "id": 214,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC HEIBONG MAKHONG",
        "id": 215,
        "type": "PHSC",
        "yes_month": [
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC IRONG CHESABA",
        "id": 216,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC IRONG KHUNOU",
        "id": 217,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC IRONG THOKCHOM",
        "id": 218,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC KEKRU",
        "id": 219,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC KHANGABOK",
        "id": 220,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC KHEKMAN",
        "id": 221,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC KIYAM LITANPOK",
        "id": 222,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC KSHETRI LEIKAI",
        "id": 223,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC LANGATHEL",
        "id": 224,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC LEIRONGTHEL MALOM",
        "id": 225,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC LITAN MAKHONG",
        "id": 226,
        "type": "PHSC",
        "yes_month": [
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC MOIJING",
        "id": 227,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC NUNGEI",
        "id": 228,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC OINAM SAWOMBUNG",
        "id": 229,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC PHUNDREI",
        "id": 230,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC SALUNGPHAM",
        "id": 231,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC TEKCHAM",
        "id": 232,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC TENTHA",
        "id": 233,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC THOKCHOM BENGI",
        "id": 234,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC THOUBAL KHUNOU",
        "id": 235,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC THOUBAL NINGOMBAM",
        "id": 236,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Nov-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC THOUBAL WANGMATABA",
        "id": 237,
        "type": "PHSC",
        "yes_month": [
            "Sep-25",
            "Oct-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC UKHONGSANG",
        "id": 238,
        "type": "PHSC",
        "yes_month": [
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC WAITHOU",
        "id": 239,
        "type": "PHSC",
        "yes_month": [
            "Aug-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "PHSC WANGKHEM",
        "id": 240,
        "type": "PHSC",
        "yes_month": [
            "Aug-25",
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHC PHOUDEL",
        "id": 241,
        "type": "UPHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHC THOUBAL BAZAR",
        "id": 242,
        "type": "UPHC",
        "yes_month": [
            "Sep-25",
            "Oct-25",
            "Nov-25",
            "Dec-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25"
        ]
    },
    {
        "district": "THOUBAL",
        "facility_name": "UPHSC KSHETRI LEIKAI TOMJIN MAKHONG",
        "id": 243,
        "type": "UPHSC",
        "yes_month": [
            "Oct-25",
            "Nov-25"
        ],
        "no_month": [
            "Jan-25",
            "Feb-25",
            "Mar-25",
            "Apr-25",
            "May-25",
            "Jun-25",
            "Jul-25",
            "Aug-25",
            "Sep-25",
            "Dec-25"
        ]
    }
]
